/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export enum AddressType {
  Both = 'both',
  Physical = 'physical',
  Postal = 'postal'
}

export enum AddressUse {
  Billing = 'billing',
  Home = 'home',
  Old = 'old',
  Temp = 'temp',
  Work = 'work'
}

export enum AdministrativeGender {
  Female = 'female',
  Male = 'male',
  Other = 'other',
  Unknown = 'unknown'
}

export enum AllergyIntoleranceCategory {
  Biologic = 'biologic',
  Environment = 'environment',
  Food = 'food',
  Medication = 'medication'
}

export enum AllergyIntoleranceCriticality {
  High = 'high',
  Low = 'low',
  UnableToAssess = 'unable_to_assess'
}

export type AllergyIntoleranceFilterParams = {
  clinicalStatus?: FilterComparatorStringSet | null | undefined;
  code?: FilterComparatorStringSet | null | undefined;
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type AllergyIntoleranceSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export enum AllergyIntoleranceType {
  Allergy = 'allergy',
  Intolerance = 'intolerance'
}

export enum Appointmentstatus {
  Arrived = 'arrived',
  Booked = 'booked',
  Cancelled = 'cancelled',
  CheckedIn = 'checked_in',
  EnteredInError = 'entered_in_error',
  Fulfilled = 'fulfilled',
  Noshow = 'noshow',
  Pending = 'pending',
  Proposed = 'proposed',
  Waitlist = 'waitlist'
}

export type CareTeamFilterParams = {
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  status?: FilterComparatorString | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type CareTeamSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export enum CareTeamStatus {
  Active = 'active',
  EnteredInError = 'entered_in_error',
  Inactive = 'inactive',
  Proposed = 'proposed',
  Suspended = 'suspended'
}

export type ClaimFilterParams = {
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type ClaimSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export enum CompositionStatus {
  Amended = 'amended',
  EnteredInError = 'entered_in_error',
  Final = 'final',
  Preliminary = 'preliminary'
}

export type ConditionFilterParams = {
  clinicalStatus?: FilterComparatorStringSet | null | undefined;
  code?: FilterComparatorStringSet | null | undefined;
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type ConditionSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export enum ContactPointSystem {
  Email = 'email',
  Fax = 'fax',
  Other = 'other',
  Pager = 'pager',
  Phone = 'phone',
  Sms = 'sms',
  Url = 'url'
}

export enum ContactPointUse {
  Home = 'home',
  Mobile = 'mobile',
  Old = 'old',
  Temp = 'temp',
  Work = 'work'
}

export type CoverageFilterParams = {
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type CoverageSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export type DiagnosticReportFilterParams = {
  code?: FilterComparatorStringSet | null | undefined;
  date?: FilterComparatorDate | null | undefined;
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type DiagnosticReportSortParams = {
  date?: Sort | null | undefined;
  lastUpdated?: Sort | null | undefined;
  name?: Sort | null | undefined;
};

export enum DiagnosticReportStatus {
  Amended = 'amended',
  Appended = 'appended',
  Cancelled = 'cancelled',
  Corrected = 'corrected',
  EnteredInError = 'entered_in_error',
  Final = 'final',
  Partial = 'partial',
  Preliminary = 'preliminary',
  Registered = 'registered',
  Unknown = 'unknown'
}

export type DocumentReferenceFilterParams = {
  date?: FilterComparatorDate | null | undefined;
  ids?: FilterComparatorStringSet | null | undefined;
  location?: FilterComparatorUri | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  status?: FilterComparatorString | null | undefined;
  subject?: FilterComparatorReference | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
  type?: FilterComparatorStringSet | null | undefined;
};

export type DocumentReferenceSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export enum DocumentReferenceStatus {
  Current = 'current',
  EnteredInError = 'entered_in_error',
  Superseded = 'superseded'
}

export type EncounterFilterParams = {
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  status?: FilterComparatorString | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export enum EncounterLocationStatus {
  Active = 'active',
  Completed = 'completed',
  Planned = 'planned',
  Reserved = 'reserved'
}

export type EncounterSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export enum EncounterStatus {
  Arrived = 'arrived',
  Cancelled = 'cancelled',
  EnteredInError = 'entered_in_error',
  Finished = 'finished',
  InProgress = 'in_progress',
  Onleave = 'onleave',
  Planned = 'planned',
  Triaged = 'triaged',
  Unknown = 'unknown'
}

export type EpisodeOfCareFilterParams = {
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export enum EpisodeOfCareStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  EnteredInError = 'entered_in_error',
  Finished = 'finished',
  Onhold = 'onhold',
  Planned = 'planned',
  Waitlist = 'waitlist'
}

export enum EventStatus {
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  InProgress = 'in_progress',
  NotDone = 'not_done',
  OnHold = 'on_hold',
  Preparation = 'preparation',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export type FilterComparatorDate = {
  eq?: unknown;
  ge?: unknown;
  gt?: unknown;
  le?: unknown;
  lt?: unknown;
  missing?: boolean | null | undefined;
};

export type FilterComparatorIdentifier = {
  eq?: string | null | undefined;
};

export type FilterComparatorReference = {
  eq?: string | null | undefined;
};

export type FilterComparatorString = {
  eq?: string | null | undefined;
  missing?: boolean | null | undefined;
  startswith?: string | null | undefined;
};

export type FilterComparatorStringSet = {
  allmatch?: Array<string> | null | undefined;
  anymatch?: Array<string> | null | undefined;
  missing?: boolean | null | undefined;
  nonematch?: Array<string> | null | undefined;
};

export type FilterComparatorUri = {
  anymatch?: Array<string> | null | undefined;
  missing?: boolean | null | undefined;
};

export enum FmStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Draft = 'draft',
  EnteredInError = 'entered_in_error'
}

export enum IdentifierUse {
  Official = 'official',
  Old = 'old',
  Secondary = 'secondary',
  Temp = 'temp',
  Usual = 'usual'
}

export type ImmunizationFilterParams = {
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  status?: FilterComparatorString | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type ImmunizationSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export enum ImmunizationStatus {
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  NotDone = 'not_done'
}

export type MedicationAdministrationFilterParams = {
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  status?: FilterComparatorString | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type MedicationAdministrationSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export type MedicationDispenseFilterParams = {
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  status?: FilterComparatorString | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type MedicationDispenseSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export type MedicationRequestFilterParams = {
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  status?: FilterComparatorString | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type MedicationRequestSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export type MedicationStatementFilterParams = {
  dateAsserted?: FilterComparatorDate | null | undefined;
  effectivePeriodStart?: FilterComparatorDate | null | undefined;
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  status?: FilterComparatorString | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type MedicationStatementSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export enum MedicationStatementStatus {
  Active = 'active',
  Completed = 'completed',
  EnteredInError = 'entered_in_error',
  Intended = 'intended',
  NotTaken = 'not_taken',
  OnHold = 'on_hold',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export enum MedicationdispenseStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Declined = 'declined',
  EnteredInError = 'entered_in_error',
  InProgress = 'in_progress',
  OnHold = 'on_hold',
  Preparation = 'preparation',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export enum MedicationrequestStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Draft = 'draft',
  EnteredInError = 'entered_in_error',
  OnHold = 'on_hold',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export enum NameUse {
  Anonymous = 'anonymous',
  Maiden = 'maiden',
  Nickname = 'nickname',
  Official = 'official',
  Old = 'old',
  Temp = 'temp',
  Usual = 'usual'
}

export type ObservationFilterParams = {
  code?: FilterComparatorStringSet | null | undefined;
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  status?: FilterComparatorString | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type ObservationSortParams = {
  date?: Sort | null | undefined;
  lastUpdated?: Sort | null | undefined;
};

export enum ObservationStatus {
  Amended = 'amended',
  Cancelled = 'cancelled',
  Corrected = 'corrected',
  EnteredInError = 'entered_in_error',
  Final = 'final',
  Preliminary = 'preliminary',
  Registered = 'registered',
  Unknown = 'unknown'
}

export enum Participationstatus {
  Accepted = 'accepted',
  Declined = 'declined',
  NeedsAction = 'needs_action',
  Tentative = 'tentative'
}

export type PatientFilterParams = {
  identifier?: FilterComparatorIdentifier | null | undefined;
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type PatientSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export type ProcedureFilterParams = {
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type ProcedureSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export enum ProvenanceEntityRole {
  Derivation = 'derivation',
  Quotation = 'quotation',
  Removal = 'removal',
  Revision = 'revision',
  Source = 'source'
}

export enum QuantityComparator {
  GreaterThan = 'greaterThan',
  GreaterThanEqual = 'greaterThanEqual',
  LessThan = 'lessThan',
  LessThanEqual = 'lessThanEqual'
}

export enum ReactionEventSeverity {
  Mild = 'mild',
  Moderate = 'moderate',
  Severe = 'severe'
}

export enum RequestIntent {
  Directive = 'directive',
  FillerOrder = 'filler_order',
  InstanceOrder = 'instance_order',
  Option = 'option',
  Order = 'order',
  OriginalOrder = 'original_order',
  Plan = 'plan',
  Proposal = 'proposal',
  ReflexOrder = 'reflex_order'
}

export enum RequestStatus {
  Active = 'active',
  Completed = 'completed',
  Draft = 'draft',
  EnteredInError = 'entered_in_error',
  OnHold = 'on_hold',
  Revoked = 'revoked',
  Unknown = 'unknown'
}

export type ServiceRequestFilterParams = {
  ids?: FilterComparatorStringSet | null | undefined;
  security?: FilterComparatorStringSet | null | undefined;
  tag?: FilterComparatorStringSet | null | undefined;
};

export type ServiceRequestSortParams = {
  lastUpdated?: Sort | null | undefined;
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type TransitionOfCareLensQueryQueryVariables = Exact<{
  id: string | number;
}>;


export type TransitionOfCareLensQueryQuery = { __typename: 'Query', EpisodeOfCare: (
    { __typename: 'EpisodeOfCare', patient: { __typename: 'Reference', resource:
        | { __typename: 'Account' }
        | { __typename: 'AllergyIntolerance' }
        | { __typename: 'Appointment' }
        | { __typename: 'AppointmentResponse' }
        | { __typename: 'Basic' }
        | { __typename: 'Binary' }
        | { __typename: 'CarePlan' }
        | { __typename: 'CareTeam' }
        | { __typename: 'Claim' }
        | { __typename: 'ClaimResponse' }
        | { __typename: 'ClinicalImpression' }
        | { __typename: 'CommunicationRequest' }
        | { __typename: 'Composition' }
        | { __typename: 'Condition' }
        | { __typename: 'Consent' }
        | { __typename: 'Contract' }
        | { __typename: 'Coverage' }
        | { __typename: 'CoverageEligibilityRequest' }
        | { __typename: 'DetectedIssue' }
        | { __typename: 'Device' }
        | { __typename: 'DeviceDefinition' }
        | { __typename: 'DeviceMetric' }
        | { __typename: 'DeviceRequest' }
        | { __typename: 'DeviceUseStatement' }
        | { __typename: 'DiagnosticReport' }
        | { __typename: 'DocumentReference' }
        | { __typename: 'Encounter' }
        | { __typename: 'Endpoint' }
        | { __typename: 'EpisodeOfCare' }
        | { __typename: 'FamilyMemberHistory' }
        | { __typename: 'Goal' }
        | { __typename: 'Group' }
        | { __typename: 'HealthcareService' }
        | { __typename: 'ImagingStudy' }
        | { __typename: 'Immunization' }
        | { __typename: 'ImmunizationEvaluation' }
        | { __typename: 'ImmunizationRecommendation' }
        | { __typename: 'InsurancePlan' }
        | { __typename: 'List' }
        | { __typename: 'Location' }
        | { __typename: 'Measure' }
        | { __typename: 'MeasureReport' }
        | { __typename: 'Media' }
        | { __typename: 'Medication' }
        | { __typename: 'MedicationAdministration' }
        | { __typename: 'MedicationDispense' }
        | { __typename: 'MedicationRequest' }
        | { __typename: 'MedicationStatement' }
        | { __typename: 'MolecularSequence' }
        | { __typename: 'NutritionOrder' }
        | { __typename: 'Observation' }
        | { __typename: 'Organization' }
        | { __typename: 'Patient', id: string | null, resourceType: string, gender: AdministrativeGender | null, birthDate: string | null, name: Array<{ __typename: 'HumanName', family: string | null, given: Array<string> | null }> | null, identifier: Array<{ __typename: 'Identifier', system: string | null, value: string | null, assigner: { __typename: 'Reference', display: string | null } | null }> | null }
        | { __typename: 'PlanDefinition' }
        | { __typename: 'Practitioner' }
        | { __typename: 'PractitionerRole' }
        | { __typename: 'Procedure' }
        | { __typename: 'Provenance' }
        | { __typename: 'Questionnaire' }
        | { __typename: 'QuestionnaireResponse' }
        | { __typename: 'RelatedPerson' }
        | { __typename: 'RequestGroup' }
        | { __typename: 'ResearchStudy' }
        | { __typename: 'RiskAssessment' }
        | { __typename: 'Schedule' }
        | { __typename: 'ServiceRequest' }
        | { __typename: 'Slot' }
        | { __typename: 'Specimen' }
        | { __typename: 'Substance' }
        | { __typename: 'SupplyRequest' }
        | { __typename: 'Task' }
        | { __typename: 'VisionPrescription' }
       | null } }
    & { ' $fragmentRefs'?: { 'EpisodeOfCareFragment': EpisodeOfCareFragment } }
  ) | null };

export type AllergiesQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: AllergyIntoleranceSortParams;
  filter?: AllergyIntoleranceFilterParams;
  first: number;
}>;


export type AllergiesQuery = { __typename: 'Query', AllergyIntoleranceConnection: { __typename: 'AllergyIntoleranceConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'AllergyIntoleranceEdge', node: { __typename: 'AllergyIntolerance', id: string | null, resourceType: string, type: AllergyIntoleranceType | null, category: Array<AllergyIntoleranceCategory> | null, criticality: AllergyIntoleranceCriticality | null, onsetDateTime: string | null, recordedDate: string | null, lastOccurrence: string | null, BasicList: Array<(
          { __typename: 'Basic' }
          & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
        )> | null, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null, display: string | null }> | null } | null, clinicalStatus: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, verificationStatus: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, code: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, patient: { __typename: 'Reference', reference: string | null, resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization' }
            | (
              { __typename: 'Patient', managingOrganization: { __typename: 'Reference', resource:
                  | { __typename: 'Account' }
                  | { __typename: 'AllergyIntolerance' }
                  | { __typename: 'Appointment' }
                  | { __typename: 'AppointmentResponse' }
                  | { __typename: 'Basic' }
                  | { __typename: 'Binary' }
                  | { __typename: 'CarePlan' }
                  | { __typename: 'CareTeam' }
                  | { __typename: 'Claim' }
                  | { __typename: 'ClaimResponse' }
                  | { __typename: 'ClinicalImpression' }
                  | { __typename: 'CommunicationRequest' }
                  | { __typename: 'Composition' }
                  | { __typename: 'Condition' }
                  | { __typename: 'Consent' }
                  | { __typename: 'Contract' }
                  | { __typename: 'Coverage' }
                  | { __typename: 'CoverageEligibilityRequest' }
                  | { __typename: 'DetectedIssue' }
                  | { __typename: 'Device' }
                  | { __typename: 'DeviceDefinition' }
                  | { __typename: 'DeviceMetric' }
                  | { __typename: 'DeviceRequest' }
                  | { __typename: 'DeviceUseStatement' }
                  | { __typename: 'DiagnosticReport' }
                  | { __typename: 'DocumentReference' }
                  | { __typename: 'Encounter' }
                  | { __typename: 'Endpoint' }
                  | { __typename: 'EpisodeOfCare' }
                  | { __typename: 'FamilyMemberHistory' }
                  | { __typename: 'Goal' }
                  | { __typename: 'Group' }
                  | { __typename: 'HealthcareService' }
                  | { __typename: 'ImagingStudy' }
                  | { __typename: 'Immunization' }
                  | { __typename: 'ImmunizationEvaluation' }
                  | { __typename: 'ImmunizationRecommendation' }
                  | { __typename: 'InsurancePlan' }
                  | { __typename: 'List' }
                  | { __typename: 'Location' }
                  | { __typename: 'Measure' }
                  | { __typename: 'MeasureReport' }
                  | { __typename: 'Media' }
                  | { __typename: 'Medication' }
                  | { __typename: 'MedicationAdministration' }
                  | { __typename: 'MedicationDispense' }
                  | { __typename: 'MedicationRequest' }
                  | { __typename: 'MedicationStatement' }
                  | { __typename: 'MolecularSequence' }
                  | { __typename: 'NutritionOrder' }
                  | { __typename: 'Observation' }
                  | { __typename: 'Organization', name: string | null }
                  | { __typename: 'Patient' }
                  | { __typename: 'PlanDefinition' }
                  | { __typename: 'Practitioner' }
                  | { __typename: 'PractitionerRole' }
                  | { __typename: 'Procedure' }
                  | { __typename: 'Provenance' }
                  | { __typename: 'Questionnaire' }
                  | { __typename: 'QuestionnaireResponse' }
                  | { __typename: 'RelatedPerson' }
                  | { __typename: 'RequestGroup' }
                  | { __typename: 'ResearchStudy' }
                  | { __typename: 'RiskAssessment' }
                  | { __typename: 'Schedule' }
                  | { __typename: 'ServiceRequest' }
                  | { __typename: 'Slot' }
                  | { __typename: 'Specimen' }
                  | { __typename: 'Substance' }
                  | { __typename: 'SupplyRequest' }
                  | { __typename: 'Task' }
                  | { __typename: 'VisionPrescription' }
                 | null } | null }
              & { ' $fragmentRefs'?: { 'PatientFragment': PatientFragment } }
            )
            | { __typename: 'PlanDefinition' }
            | { __typename: 'Practitioner' }
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null }, encounter: { __typename: 'Reference', reference: string | null, resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | (
              { __typename: 'Encounter' }
              & { ' $fragmentRefs'?: { 'EncounterReferenceFragment': EncounterReferenceFragment } }
            )
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization' }
            | { __typename: 'Patient' }
            | { __typename: 'PlanDefinition' }
            | { __typename: 'Practitioner' }
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null } | null, onsetAge: { __typename: 'Age', value: number | null, unit: string | null, system: string | null, code: string | null } | null, onsetPeriod: { __typename: 'Period', start: string | null, end: string | null } | null, recorder: { __typename: 'Reference', reference: string | null, resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization' }
            | { __typename: 'Patient' }
            | { __typename: 'PlanDefinition' }
            | (
              { __typename: 'Practitioner' }
              & { ' $fragmentRefs'?: { 'PractitionerFragment': PractitionerFragment } }
            )
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null } | null, note: Array<{ __typename: 'Annotation', text: string, time: string | null }> | null, reaction: Array<{ __typename: 'AllergyIntoleranceReaction', onset: string | null, severity: ReactionEventSeverity | null, substance: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
              { __typename: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null } | null, manifestation: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<(
              { __typename: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null }>, note: Array<{ __typename: 'Annotation', text: string, time: string | null }> | null }> | null } }> | null } | null };

export type AppointmentsQueryVariables = Exact<{
  upid: string | number;
}>;


export type AppointmentsQuery = { __typename: 'Query', AppointmentConnection: { __typename: 'AppointmentConnection', edges: Array<{ __typename: 'AppointmentEdge', node: (
        { __typename: 'Appointment' }
        & { ' $fragmentRefs'?: { 'AppointmentFragment': AppointmentFragment } }
      ) }> | null } | null };

export type CareTeamsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: CareTeamSortParams;
  filter?: CareTeamFilterParams;
  first: number;
}>;


export type CareTeamsQuery = { __typename: 'Query', CareTeamConnection: { __typename: 'CareTeamConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'CareTeamEdge', node: { __typename: 'CareTeam', id: string | null, resourceType: string, status: CareTeamStatus | null, name: string | null, meta: { __typename: 'Meta', versionId: string | null, extension: Array<{ __typename: 'Extension', url: string, valueInstant: string | null }> | null, tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, category: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, period: { __typename: 'Period', start: string | null, end: string | null } | null, participant: Array<{ __typename: 'CareTeamParticipant', role: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<(
              { __typename: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null }> | null, member: { __typename: 'Reference', reference: string | null, resource:
              | { __typename: 'Account' }
              | { __typename: 'AllergyIntolerance' }
              | { __typename: 'Appointment' }
              | { __typename: 'AppointmentResponse' }
              | { __typename: 'Basic' }
              | { __typename: 'Binary' }
              | { __typename: 'CarePlan' }
              | { __typename: 'CareTeam' }
              | { __typename: 'Claim' }
              | { __typename: 'ClaimResponse' }
              | { __typename: 'ClinicalImpression' }
              | { __typename: 'CommunicationRequest' }
              | { __typename: 'Composition' }
              | { __typename: 'Condition' }
              | { __typename: 'Consent' }
              | { __typename: 'Contract' }
              | { __typename: 'Coverage' }
              | { __typename: 'CoverageEligibilityRequest' }
              | { __typename: 'DetectedIssue' }
              | { __typename: 'Device' }
              | { __typename: 'DeviceDefinition' }
              | { __typename: 'DeviceMetric' }
              | { __typename: 'DeviceRequest' }
              | { __typename: 'DeviceUseStatement' }
              | { __typename: 'DiagnosticReport' }
              | { __typename: 'DocumentReference' }
              | { __typename: 'Encounter' }
              | { __typename: 'Endpoint' }
              | { __typename: 'EpisodeOfCare' }
              | { __typename: 'FamilyMemberHistory' }
              | { __typename: 'Goal' }
              | { __typename: 'Group' }
              | { __typename: 'HealthcareService' }
              | { __typename: 'ImagingStudy' }
              | { __typename: 'Immunization' }
              | { __typename: 'ImmunizationEvaluation' }
              | { __typename: 'ImmunizationRecommendation' }
              | { __typename: 'InsurancePlan' }
              | { __typename: 'List' }
              | { __typename: 'Location' }
              | { __typename: 'Measure' }
              | { __typename: 'MeasureReport' }
              | { __typename: 'Media' }
              | { __typename: 'Medication' }
              | { __typename: 'MedicationAdministration' }
              | { __typename: 'MedicationDispense' }
              | { __typename: 'MedicationRequest' }
              | { __typename: 'MedicationStatement' }
              | { __typename: 'MolecularSequence' }
              | { __typename: 'NutritionOrder' }
              | { __typename: 'Observation' }
              | { __typename: 'Organization' }
              | { __typename: 'Patient' }
              | { __typename: 'PlanDefinition' }
              | (
                { __typename: 'Practitioner' }
                & { ' $fragmentRefs'?: { 'PractitionerFragment': PractitionerFragment } }
              )
              | { __typename: 'PractitionerRole' }
              | { __typename: 'Procedure' }
              | { __typename: 'Provenance' }
              | { __typename: 'Questionnaire' }
              | { __typename: 'QuestionnaireResponse' }
              | { __typename: 'RelatedPerson' }
              | { __typename: 'RequestGroup' }
              | { __typename: 'ResearchStudy' }
              | { __typename: 'RiskAssessment' }
              | { __typename: 'Schedule' }
              | { __typename: 'ServiceRequest' }
              | { __typename: 'Slot' }
              | { __typename: 'Specimen' }
              | { __typename: 'Substance' }
              | { __typename: 'SupplyRequest' }
              | { __typename: 'Task' }
              | { __typename: 'VisionPrescription' }
             | null } | null, onBehalfOf: { __typename: 'Reference', reference: string | null } | null }> | null, reasonCode: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, telecom: Array<{ __typename: 'ContactPoint', system: ContactPointSystem | null, value: string | null, use: ContactPointUse | null, period: { __typename: 'Period', start: string | null, end: string | null } | null }> | null, note: Array<{ __typename: 'Annotation', text: string }> | null } }> | null } | null };

export type ClaimsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  filter?: ClaimFilterParams;
  sort: ClaimSortParams;
  first: number;
}>;


export type ClaimsQuery = { __typename: 'Query', ClaimConnection: { __typename: 'ClaimConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'ClaimEdge', node: (
        { __typename: 'Claim' }
        & { ' $fragmentRefs'?: { 'ClaimFragment': ClaimFragment } }
      ) }> | null } | null };

export type ConditionsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  filter?: ConditionFilterParams;
  sort: ConditionSortParams;
  first: number;
}>;


export type ConditionsQuery = { __typename: 'Query', ConditionConnection: { __typename: 'ConditionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'ConditionEdge', node: (
        { __typename: 'Condition' }
        & { ' $fragmentRefs'?: { 'ConditionFragment': ConditionFragment } }
      ) }> | null } | null };

export type ConditionFragment = { __typename: 'Condition', id: string | null, resourceType: string, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, code: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', system: string | null, code: string | null, display: string | null }> | null } | null } & { ' $fragmentName'?: 'ConditionFragment' };

export type FirstPartyConditionsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  filter?: ConditionFilterParams;
  sort: ConditionSortParams;
  first: number;
}>;


export type FirstPartyConditionsQuery = { __typename: 'Query', ConditionConnection: { __typename: 'ConditionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'ConditionEdge', node: (
        { __typename: 'Condition' }
        & { ' $fragmentRefs'?: { 'ConditionFragment': ConditionFragment } }
      ) }> | null } | null };

export type CoverageQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  filter?: CoverageFilterParams;
  sort: CoverageSortParams;
  first: number;
}>;


export type CoverageQuery = { __typename: 'Query', CoverageConnection: { __typename: 'CoverageConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'CoverageEdge', node: { __typename: 'Coverage', id: string | null, resourceType: string, order: number | null, status: FmStatus, subscriberId: string | null, meta: { __typename: 'Meta', lastUpdated: string | null, extension: Array<{ __typename: 'Extension', url: string, valueReference: { __typename: 'Reference', reference: string | null } | null }> | null, tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, beneficiary: { __typename: 'Reference', reference: string | null }, class: Array<{ __typename: 'CoverageClass', value: string, name: string | null, type: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
              { __typename: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null } }> | null, period: { __typename: 'Period', start: string | null } | null, type: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, payor: Array<{ __typename: 'Reference', display: string | null }>, relationship: { __typename: 'CodeableConcept', coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, subscriber: { __typename: 'Reference', reference: string | null, resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization' }
            | (
              { __typename: 'Patient' }
              & { ' $fragmentRefs'?: { 'PatientFragment': PatientFragment } }
            )
            | { __typename: 'PlanDefinition' }
            | { __typename: 'Practitioner' }
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null } | null } }> | null } | null };

export type DiagnosticReportOverviewFragment = { __typename: 'DiagnosticReport', id: string | null, resourceType: string, effectiveDateTime: string | null, issued: string | null, BasicList: Array<(
    { __typename: 'Basic' }
    & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
  )> | null, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null, extension: Array<{ __typename: 'Extension', url: string, valueInstant: string | null }> | null } | null, code: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
      { __typename: 'Coding' }
      & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
    )> | null }, effectivePeriod: { __typename: 'Period', start: string | null } | null, performer: Array<{ __typename: 'Reference', reference: string | null, display: string | null }> | null, subject: { __typename: 'Reference', reference: string | null } | null, result: Array<{ __typename: 'Reference', reference: string | null, display: string | null }> | null } & { ' $fragmentName'?: 'DiagnosticReportOverviewFragment' };

export type DiagnosticReportsOverviewQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: DiagnosticReportSortParams;
  filter: DiagnosticReportFilterParams;
  first: number;
}>;


export type DiagnosticReportsOverviewQuery = { __typename: 'Query', DiagnosticReportConnection: { __typename: 'DiagnosticReportConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string, total: number | null }, edges: Array<{ __typename: 'DiagnosticReportEdge', node: (
        { __typename: 'DiagnosticReport' }
        & { ' $fragmentRefs'?: { 'DiagnosticReportOverviewFragment': DiagnosticReportOverviewFragment } }
      ) }> | null } | null };

export type DiagnosticReportsCursorQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: DiagnosticReportSortParams;
  filter: DiagnosticReportFilterParams;
  first: number;
}>;


export type DiagnosticReportsCursorQuery = { __typename: 'Query', DiagnosticReportConnection: { __typename: 'DiagnosticReportConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'DiagnosticReportEdge', node: { __typename: 'DiagnosticReport', id: string | null } }> | null } | null };

export type DiagnosticReportsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: DiagnosticReportSortParams;
  filter: DiagnosticReportFilterParams;
  first: number;
}>;


export type DiagnosticReportsQuery = { __typename: 'Query', DiagnosticReportConnection: { __typename: 'DiagnosticReportConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'DiagnosticReportEdge', node: { __typename: 'DiagnosticReport', id: string | null, resourceType: string, status: DiagnosticReportStatus, effectiveDateTime: string | null, issued: string | null, conclusion: string | null, BasicList: Array<(
          { __typename: 'Basic' }
          & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
        )> | null, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null, extension: Array<{ __typename: 'Extension', url: string, valueInstant: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, category: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, code: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }, effectivePeriod: { __typename: 'Period', start: string | null, end: string | null } | null, performer: Array<{ __typename: 'Reference', reference: string | null, resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization' }
            | { __typename: 'Patient' }
            | { __typename: 'PlanDefinition' }
            | (
              { __typename: 'Practitioner' }
              & { ' $fragmentRefs'?: { 'PractitionerFragment': PractitionerFragment } }
            )
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null }> | null, subject: { __typename: 'Reference', reference: string | null, resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization' }
            | (
              { __typename: 'Patient' }
              & { ' $fragmentRefs'?: { 'PatientFragment': PatientFragment } }
            )
            | { __typename: 'PlanDefinition' }
            | { __typename: 'Practitioner' }
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null } | null, result: Array<{ __typename: 'Reference', reference: string | null, display: string | null }> | null } }> | null } | null };

export type DocumentFragment = { __typename: 'DocumentReference', id: string | null, resourceType: string, status: DocumentReferenceStatus, docStatus: CompositionStatus | null, date: string | null, description: string | null, masterIdentifier: { __typename: 'Identifier', system: string | null, use: IdentifierUse | null, value: string | null } | null, meta: { __typename: 'Meta', versionId: string | null, extension: Array<{ __typename: 'Extension', url: string, valueInstant: string | null }> | null, tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, type: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
      { __typename: 'Coding' }
      & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
    )> | null } | null, text: { __typename: 'Narrative', id: string | null, div: string } | null, category: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<(
      { __typename: 'Coding' }
      & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
    )> | null }> | null, subject: { __typename: 'Reference', reference: string | null, display: string | null } | null, author: Array<{ __typename: 'Reference', reference: string | null, display: string | null }> | null, custodian: { __typename: 'Reference', reference: string | null, display: string | null } | null, content: Array<{ __typename: 'DocumentReferenceContent', attachment: { __typename: 'Attachment', contentType: string | null, language: string | null, data: string | null, url: string | null, size: number | null, hash: string | null, title: string | null, creation: string | null }, format: { __typename: 'Coding', system: string | null, version: string | null, code: string | null, display: string | null } | null }>, context: { __typename: 'DocumentReferenceContext', period: { __typename: 'Period', start: string | null, end: string | null } | null, encounter: Array<{ __typename: 'Reference', reference: string | null }> | null } | null } & { ' $fragmentName'?: 'DocumentFragment' };

export type DocumentWithBasicsFragment = (
  { __typename: 'DocumentReference', BasicList: Array<(
    { __typename: 'Basic' }
    & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
  )> | null }
  & { ' $fragmentRefs'?: { 'DocumentFragment': DocumentFragment } }
) & { ' $fragmentName'?: 'DocumentWithBasicsFragment' };

export type DocumentReferencesWithBasicsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: DocumentReferenceSortParams;
  filter?: DocumentReferenceFilterParams;
  first: number;
}>;


export type DocumentReferencesWithBasicsQuery = { __typename: 'Query', DocumentReferenceConnection: { __typename: 'DocumentReferenceConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'DocumentReferenceEdge', node: (
        { __typename: 'DocumentReference' }
        & { ' $fragmentRefs'?: { 'DocumentWithBasicsFragment': DocumentWithBasicsFragment } }
      ) }> | null } | null };

export type DocumentReferencesQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: DocumentReferenceSortParams;
  filter?: DocumentReferenceFilterParams;
  first: number;
}>;


export type DocumentReferencesQuery = { __typename: 'Query', DocumentReferenceConnection: { __typename: 'DocumentReferenceConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'DocumentReferenceEdge', node: (
        { __typename: 'DocumentReference' }
        & { ' $fragmentRefs'?: { 'DocumentFragment': DocumentFragment } }
      ) }> | null } | null };

export type DocumentReferencesListQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: DocumentReferenceSortParams;
  filter?: DocumentReferenceFilterParams;
  first: number;
}>;


export type DocumentReferencesListQuery = { __typename: 'Query', DocumentReferenceConnection: { __typename: 'DocumentReferenceConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'DocumentReferenceEdge', node: { __typename: 'DocumentReference', id: string | null, resourceType: string, status: DocumentReferenceStatus, docStatus: CompositionStatus | null, date: string | null, description: string | null, BasicList: Array<(
          { __typename: 'Basic' }
          & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
        )> | null, masterIdentifier: { __typename: 'Identifier', system: string | null, use: IdentifierUse | null, value: string | null } | null, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, type: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, category: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, custodian: { __typename: 'Reference', reference: string | null, display: string | null } | null, content: Array<{ __typename: 'DocumentReferenceContent', attachment: { __typename: 'Attachment', contentType: string | null, url: string | null, creation: string | null } }>, context: { __typename: 'DocumentReferenceContext', period: { __typename: 'Period', start: string | null, end: string | null } | null } | null } }> | null } | null };

export type EncountersQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: EncounterSortParams;
  first: number;
  filter?: EncounterFilterParams;
}>;


export type EncountersQuery = { __typename: 'Query', EncounterConnection: { __typename: 'EncounterConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'EncounterEdge', node: (
        { __typename: 'Encounter' }
        & { ' $fragmentRefs'?: { 'EncounterFragment': EncounterFragment } }
      ) }> | null } | null };

export type EpisodeOfCareOverviewQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  first: number;
  filter: EpisodeOfCareFilterParams;
}>;


export type EpisodeOfCareOverviewQuery = { __typename: 'Query', EpisodeOfCareConnection: { __typename: 'EpisodeOfCareConnection', pageInfo: { __typename: 'PageInfo', endCursor: string, hasNextPage: boolean }, edges: Array<{ __typename: 'EpisodeOfCareEdge', node: (
        { __typename: 'EpisodeOfCare' }
        & { ' $fragmentRefs'?: { 'EpisodeOfCareOverviewFragment': EpisodeOfCareOverviewFragment } }
      ) }> | null } | null };

export type EpisodeOfCareQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  first: number;
  filter: EpisodeOfCareFilterParams;
}>;


export type EpisodeOfCareQuery = { __typename: 'Query', EpisodeOfCareConnection: { __typename: 'EpisodeOfCareConnection', pageInfo: { __typename: 'PageInfo', endCursor: string, hasNextPage: boolean }, edges: Array<{ __typename: 'EpisodeOfCareEdge', node: (
        { __typename: 'EpisodeOfCare' }
        & { ' $fragmentRefs'?: { 'EpisodeOfCareFragment': EpisodeOfCareFragment } }
      ) }> | null } | null };

export type BasicFragment = { __typename: 'Basic', id: string | null, resourceType: string, meta: { __typename: 'Meta', lastUpdated: string | null, tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, code: { __typename: 'CodeableConcept', coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null }> | null }, author: { __typename: 'Reference', display: string | null } | null } & { ' $fragmentName'?: 'BasicFragment' };

export type CodingFragment = { __typename: 'Coding', code: string | null, display: string | null, system: string | null, version: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null, valueCoding: { __typename: 'Coding', code: string | null, display: string | null, system: string | null } | null }> | null } & { ' $fragmentName'?: 'CodingFragment' };

export type EncounterReferenceFragment = { __typename: 'Encounter', id: string | null, resourceType: string, status: EncounterStatus, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, priority: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null }> | null } | null } & { ' $fragmentName'?: 'EncounterReferenceFragment' };

export type PractitionerFragment = { __typename: 'Practitioner', id: string | null, resourceType: string, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, name: Array<{ __typename: 'HumanName', family: string | null, given: Array<string> | null, prefix: Array<string> | null, suffix: Array<string> | null, text: string | null, use: NameUse | null }> | null, qualification: Array<{ __typename: 'PractitionerQualification', code: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null }> | null }, period: { __typename: 'Period', start: string | null, end: string | null } | null }> | null } & { ' $fragmentName'?: 'PractitionerFragment' };

export type ServiceRequestFragment = { __typename: 'ServiceRequest', id: string | null, resourceType: string, status: RequestStatus, intent: RequestIntent, authoredOn: string | null, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, subject: { __typename: 'Reference', reference: string | null }, identifier: Array<{ __typename: 'Identifier', system: string | null, value: string | null }> | null, requester: { __typename: 'Reference', reference: string | null, display: string | null, resource:
      | { __typename: 'Account' }
      | { __typename: 'AllergyIntolerance' }
      | { __typename: 'Appointment' }
      | { __typename: 'AppointmentResponse' }
      | { __typename: 'Basic' }
      | { __typename: 'Binary' }
      | { __typename: 'CarePlan' }
      | { __typename: 'CareTeam' }
      | { __typename: 'Claim' }
      | { __typename: 'ClaimResponse' }
      | { __typename: 'ClinicalImpression' }
      | { __typename: 'CommunicationRequest' }
      | { __typename: 'Composition' }
      | { __typename: 'Condition' }
      | { __typename: 'Consent' }
      | { __typename: 'Contract' }
      | { __typename: 'Coverage' }
      | { __typename: 'CoverageEligibilityRequest' }
      | { __typename: 'DetectedIssue' }
      | { __typename: 'Device' }
      | { __typename: 'DeviceDefinition' }
      | { __typename: 'DeviceMetric' }
      | { __typename: 'DeviceRequest' }
      | { __typename: 'DeviceUseStatement' }
      | { __typename: 'DiagnosticReport' }
      | { __typename: 'DocumentReference' }
      | { __typename: 'Encounter' }
      | { __typename: 'Endpoint' }
      | { __typename: 'EpisodeOfCare' }
      | { __typename: 'FamilyMemberHistory' }
      | { __typename: 'Goal' }
      | { __typename: 'Group' }
      | { __typename: 'HealthcareService' }
      | { __typename: 'ImagingStudy' }
      | { __typename: 'Immunization' }
      | { __typename: 'ImmunizationEvaluation' }
      | { __typename: 'ImmunizationRecommendation' }
      | { __typename: 'InsurancePlan' }
      | { __typename: 'List' }
      | { __typename: 'Location' }
      | { __typename: 'Measure' }
      | { __typename: 'MeasureReport' }
      | { __typename: 'Media' }
      | { __typename: 'Medication' }
      | { __typename: 'MedicationAdministration' }
      | { __typename: 'MedicationDispense' }
      | { __typename: 'MedicationRequest' }
      | { __typename: 'MedicationStatement' }
      | { __typename: 'MolecularSequence' }
      | { __typename: 'NutritionOrder' }
      | { __typename: 'Observation' }
      | { __typename: 'Organization' }
      | { __typename: 'Patient' }
      | { __typename: 'PlanDefinition' }
      | { __typename: 'Practitioner', id: string | null, resourceType: string, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, name: Array<{ __typename: 'HumanName', family: string | null, given: Array<string> | null, prefix: Array<string> | null, suffix: Array<string> | null, text: string | null, use: NameUse | null }> | null, qualification: Array<{ __typename: 'PractitionerQualification', code: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null }> | null }, period: { __typename: 'Period', start: string | null, end: string | null } | null }> | null }
      | { __typename: 'PractitionerRole' }
      | { __typename: 'Procedure' }
      | { __typename: 'Provenance' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'RelatedPerson' }
      | { __typename: 'RequestGroup' }
      | { __typename: 'ResearchStudy' }
      | { __typename: 'RiskAssessment' }
      | { __typename: 'Schedule' }
      | { __typename: 'ServiceRequest' }
      | { __typename: 'Slot' }
      | { __typename: 'Specimen' }
      | { __typename: 'Substance' }
      | { __typename: 'SupplyRequest' }
      | { __typename: 'Task' }
      | { __typename: 'VisionPrescription' }
     | null, identifier: { __typename: 'Identifier', system: string | null, value: string | null } | null } | null, reasonCode: Array<{ __typename: 'CodeableConcept', text: string | null }> | null, category: Array<{ __typename: 'CodeableConcept', text: string | null }> | null, performer: Array<{ __typename: 'Reference', reference: string | null, display: string | null, identifier: { __typename: 'Identifier', system: string | null, value: string | null } | null }> | null, locationReference: Array<{ __typename: 'Reference', reference: string | null, display: string | null }> | null } & { ' $fragmentName'?: 'ServiceRequestFragment' };

export type AppointmentFragment = { __typename: 'Appointment', id: string | null, resourceType: string, status: Appointmentstatus, start: string | null, end: string | null, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, participant: Array<{ __typename: 'AppointmentParticipant', status: Participationstatus, actor: { __typename: 'Reference', reference: string | null, display: string | null, identifier: { __typename: 'Identifier', system: string | null, value: string | null } | null } | null }>, basedOn: Array<{ __typename: 'Reference', reference: string | null }> | null, serviceType: Array<{ __typename: 'CodeableConcept', text: string | null }> | null, appointmentType: { __typename: 'CodeableConcept', text: string | null } | null, serviceCategory: Array<{ __typename: 'CodeableConcept', text: string | null }> | null, specialty: Array<{ __typename: 'CodeableConcept', text: string | null }> | null } & { ' $fragmentName'?: 'AppointmentFragment' };

export type PatientFragment = { __typename: 'Patient', id: string | null, resourceType: string, active: boolean | null, birthDate: string | null, gender: AdministrativeGender | null, meta: { __typename: 'Meta', versionId: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null, valueInstant: string | null }> | null, tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, identifier: Array<{ __typename: 'Identifier', use: IdentifierUse | null, system: string | null, value: string | null }> | null, contact: Array<{ __typename: 'PatientContact', gender: AdministrativeGender | null, address: { __typename: 'Address', city: string | null, country: string | null, district: string | null, line: Array<string> | null, postalCode: string | null, state: string | null, text: string | null, type: AddressType | null, use: AddressUse | null, period: { __typename: 'Period', start: string | null, end: string | null } | null } | null, name: { __typename: 'HumanName', family: string | null, given: Array<string> | null, prefix: Array<string> | null, suffix: Array<string> | null, text: string | null, use: NameUse | null } | null, organization: { __typename: 'Reference', display: string | null, type: string | null, identifier: { __typename: 'Identifier', value: string | null } | null } | null }> | null, maritalStatus: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null }> | null } | null, telecom: Array<{ __typename: 'ContactPoint', use: ContactPointUse | null, value: string | null, system: ContactPointSystem | null }> | null, address: Array<{ __typename: 'Address', city: string | null, country: string | null, district: string | null, line: Array<string> | null, postalCode: string | null, state: string | null, text: string | null, type: AddressType | null, use: AddressUse | null, period: { __typename: 'Period', start: string | null, end: string | null } | null }> | null, name: Array<{ __typename: 'HumanName', family: string | null, given: Array<string> | null, prefix: Array<string> | null, suffix: Array<string> | null, text: string | null, use: NameUse | null, period: { __typename: 'Period', start: string | null, end: string | null } | null }> | null, managingOrganization: { __typename: 'Reference', resource:
      | { __typename: 'Account' }
      | { __typename: 'AllergyIntolerance' }
      | { __typename: 'Appointment' }
      | { __typename: 'AppointmentResponse' }
      | { __typename: 'Basic' }
      | { __typename: 'Binary' }
      | { __typename: 'CarePlan' }
      | { __typename: 'CareTeam' }
      | { __typename: 'Claim' }
      | { __typename: 'ClaimResponse' }
      | { __typename: 'ClinicalImpression' }
      | { __typename: 'CommunicationRequest' }
      | { __typename: 'Composition' }
      | { __typename: 'Condition' }
      | { __typename: 'Consent' }
      | { __typename: 'Contract' }
      | { __typename: 'Coverage' }
      | { __typename: 'CoverageEligibilityRequest' }
      | { __typename: 'DetectedIssue' }
      | { __typename: 'Device' }
      | { __typename: 'DeviceDefinition' }
      | { __typename: 'DeviceMetric' }
      | { __typename: 'DeviceRequest' }
      | { __typename: 'DeviceUseStatement' }
      | { __typename: 'DiagnosticReport' }
      | { __typename: 'DocumentReference' }
      | { __typename: 'Encounter' }
      | { __typename: 'Endpoint' }
      | { __typename: 'EpisodeOfCare' }
      | { __typename: 'FamilyMemberHistory' }
      | { __typename: 'Goal' }
      | { __typename: 'Group' }
      | { __typename: 'HealthcareService' }
      | { __typename: 'ImagingStudy' }
      | { __typename: 'Immunization' }
      | { __typename: 'ImmunizationEvaluation' }
      | { __typename: 'ImmunizationRecommendation' }
      | { __typename: 'InsurancePlan' }
      | { __typename: 'List' }
      | { __typename: 'Location' }
      | { __typename: 'Measure' }
      | { __typename: 'MeasureReport' }
      | { __typename: 'Media' }
      | { __typename: 'Medication' }
      | { __typename: 'MedicationAdministration' }
      | { __typename: 'MedicationDispense' }
      | { __typename: 'MedicationRequest' }
      | { __typename: 'MedicationStatement' }
      | { __typename: 'MolecularSequence' }
      | { __typename: 'NutritionOrder' }
      | { __typename: 'Observation' }
      | (
        { __typename: 'Organization' }
        & { ' $fragmentRefs'?: { 'OrganizationFragment': OrganizationFragment } }
      )
      | { __typename: 'Patient' }
      | { __typename: 'PlanDefinition' }
      | { __typename: 'Practitioner' }
      | { __typename: 'PractitionerRole' }
      | { __typename: 'Procedure' }
      | { __typename: 'Provenance' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'RelatedPerson' }
      | { __typename: 'RequestGroup' }
      | { __typename: 'ResearchStudy' }
      | { __typename: 'RiskAssessment' }
      | { __typename: 'Schedule' }
      | { __typename: 'ServiceRequest' }
      | { __typename: 'Slot' }
      | { __typename: 'Specimen' }
      | { __typename: 'Substance' }
      | { __typename: 'SupplyRequest' }
      | { __typename: 'Task' }
      | { __typename: 'VisionPrescription' }
     | null } | null } & { ' $fragmentName'?: 'PatientFragment' };

export type PatientListItemFragment = { __typename: 'Patient', id: string | null, resourceType: string, birthDate: string | null, gender: AdministrativeGender | null, meta: { __typename: 'Meta', versionId: string | null, lastUpdated: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null, valueInstant: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, identifier: Array<{ __typename: 'Identifier', use: IdentifierUse | null, system: string | null, value: string | null }> | null, name: Array<{ __typename: 'HumanName', family: string | null, given: Array<string> | null, prefix: Array<string> | null, suffix: Array<string> | null, text: string | null, use: NameUse | null, period: { __typename: 'Period', start: string | null, end: string | null } | null }> | null, telecom: Array<{ __typename: 'ContactPoint', use: ContactPointUse | null, value: string | null, system: ContactPointSystem | null }> | null } & { ' $fragmentName'?: 'PatientListItemFragment' };

export type ReferenceFragment = { __typename: 'Reference', id: string | null, reference: string | null, type: string | null, display: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, identifier: { __typename: 'Identifier', id: string | null, system: string | null, value: string | null } | null } & { ' $fragmentName'?: 'ReferenceFragment' };

export type ObservationLiteFragment = { __typename: 'Observation', id: string | null, resourceType: string, effectiveDateTime: string | null, valueString: string | null, valueBoolean: boolean | null, valueInteger: number | null, valueTime: string | null, valueDateTime: string | null, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, effectivePeriod: { __typename: 'Period', start: string | null } | null, referenceRange: Array<{ __typename: 'ObservationReferenceRange', text: string | null }> | null, code: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null }> | null }, valueQuantity: { __typename: 'Quantity', comparator: QuantityComparator | null, unit: string | null, value: number | null, system: string | null, code: string | null } | null, valueCodeableConcept: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', system: string | null, code: string | null, display: string | null }> | null } | null, valueRange: { __typename: 'Range', low: { __typename: 'Quantity', unit: string | null, value: number | null, system: string | null, code: string | null } | null, high: { __typename: 'Quantity', unit: string | null, value: number | null, system: string | null, code: string | null } | null } | null, valuePeriod: { __typename: 'Period', start: string | null, end: string | null } | null, interpretation: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null }> | null }> | null, note: Array<{ __typename: 'Annotation', text: string }> | null } & { ' $fragmentName'?: 'ObservationLiteFragment' };

export type ObservationFragment = { __typename: 'Observation', id: string | null, resourceType: string, status: ObservationStatus, effectiveDateTime: string | null, valueString: string | null, valueBoolean: boolean | null, valueInteger: number | null, valueTime: string | null, valueDateTime: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, encounter: { __typename: 'Reference', reference: string | null } | null, category: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null }> | null }> | null, effectivePeriod: { __typename: 'Period', start: string | null, end: string | null } | null, referenceRange: Array<{ __typename: 'ObservationReferenceRange', text: string | null }> | null, code: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null }> | null }, component: Array<{ __typename: 'ObservationComponent', valueString: string | null, code: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null }> | null }, valueQuantity: { __typename: 'Quantity', unit: string | null, value: number | null } | null }> | null, ProvenanceList: Array<{ __typename: 'Provenance', id: string | null, entity: Array<{ __typename: 'ProvenanceEntity', what: (
        { __typename: 'Reference' }
        & { ' $fragmentRefs'?: { 'ReferenceFragment': ReferenceFragment } }
      ) }> | null }> | null, valueQuantity: { __typename: 'Quantity', comparator: QuantityComparator | null, unit: string | null, value: number | null, system: string | null, code: string | null } | null, valueCodeableConcept: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', system: string | null, code: string | null, display: string | null }> | null } | null, valueRange: { __typename: 'Range', low: { __typename: 'Quantity', unit: string | null, value: number | null, system: string | null, code: string | null } | null, high: { __typename: 'Quantity', unit: string | null, value: number | null, system: string | null, code: string | null } | null } | null, valueRatio: { __typename: 'Ratio', numerator: { __typename: 'Quantity', comparator: QuantityComparator | null, unit: string | null, value: number | null, system: string | null, code: string | null } | null, denominator: { __typename: 'Quantity', unit: string | null, value: number | null, system: string | null, code: string | null } | null } | null, valuePeriod: { __typename: 'Period', start: string | null, end: string | null } | null, interpretation: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null }> | null }> | null, subject: { __typename: 'Reference', resource:
      | { __typename: 'Account' }
      | { __typename: 'AllergyIntolerance' }
      | { __typename: 'Appointment' }
      | { __typename: 'AppointmentResponse' }
      | { __typename: 'Basic' }
      | { __typename: 'Binary' }
      | { __typename: 'CarePlan' }
      | { __typename: 'CareTeam' }
      | { __typename: 'Claim' }
      | { __typename: 'ClaimResponse' }
      | { __typename: 'ClinicalImpression' }
      | { __typename: 'CommunicationRequest' }
      | { __typename: 'Composition' }
      | { __typename: 'Condition' }
      | { __typename: 'Consent' }
      | { __typename: 'Contract' }
      | { __typename: 'Coverage' }
      | { __typename: 'CoverageEligibilityRequest' }
      | { __typename: 'DetectedIssue' }
      | { __typename: 'Device' }
      | { __typename: 'DeviceDefinition' }
      | { __typename: 'DeviceMetric' }
      | { __typename: 'DeviceRequest' }
      | { __typename: 'DeviceUseStatement' }
      | { __typename: 'DiagnosticReport' }
      | { __typename: 'DocumentReference' }
      | { __typename: 'Encounter' }
      | { __typename: 'Endpoint' }
      | { __typename: 'EpisodeOfCare' }
      | { __typename: 'FamilyMemberHistory' }
      | { __typename: 'Goal' }
      | { __typename: 'Group' }
      | { __typename: 'HealthcareService' }
      | { __typename: 'ImagingStudy' }
      | { __typename: 'Immunization' }
      | { __typename: 'ImmunizationEvaluation' }
      | { __typename: 'ImmunizationRecommendation' }
      | { __typename: 'InsurancePlan' }
      | { __typename: 'List' }
      | { __typename: 'Location' }
      | { __typename: 'Measure' }
      | { __typename: 'MeasureReport' }
      | { __typename: 'Media' }
      | { __typename: 'Medication' }
      | { __typename: 'MedicationAdministration' }
      | { __typename: 'MedicationDispense' }
      | { __typename: 'MedicationRequest' }
      | { __typename: 'MedicationStatement' }
      | { __typename: 'MolecularSequence' }
      | { __typename: 'NutritionOrder' }
      | { __typename: 'Observation' }
      | { __typename: 'Organization' }
      | { __typename: 'Patient', managingOrganization: { __typename: 'Reference', resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization', name: string | null }
            | { __typename: 'Patient' }
            | { __typename: 'PlanDefinition' }
            | { __typename: 'Practitioner' }
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null } | null }
      | { __typename: 'PlanDefinition' }
      | { __typename: 'Practitioner' }
      | { __typename: 'PractitionerRole' }
      | { __typename: 'Procedure' }
      | { __typename: 'Provenance' }
      | { __typename: 'Questionnaire' }
      | { __typename: 'QuestionnaireResponse' }
      | { __typename: 'RelatedPerson' }
      | { __typename: 'RequestGroup' }
      | { __typename: 'ResearchStudy' }
      | { __typename: 'RiskAssessment' }
      | { __typename: 'Schedule' }
      | { __typename: 'ServiceRequest' }
      | { __typename: 'Slot' }
      | { __typename: 'Specimen' }
      | { __typename: 'Substance' }
      | { __typename: 'SupplyRequest' }
      | { __typename: 'Task' }
      | { __typename: 'VisionPrescription' }
     | null } | null, note: Array<{ __typename: 'Annotation', text: string }> | null } & { ' $fragmentName'?: 'ObservationFragment' };

export type OrganizationFragment = { __typename: 'Organization', id: string | null, resourceType: string, name: string | null, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, telecom: Array<{ __typename: 'ContactPoint', system: ContactPointSystem | null, value: string | null, period: { __typename: 'Period', start: string | null, end: string | null } | null }> | null, contact: Array<{ __typename: 'OrganizationContact', purpose: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', code: string | null, display: string | null, system: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null }> | null } | null, name: { __typename: 'HumanName', family: string | null, given: Array<string> | null, prefix: Array<string> | null, suffix: Array<string> | null, text: string | null, use: NameUse | null } | null, telecom: Array<{ __typename: 'ContactPoint', system: ContactPointSystem | null, value: string | null, period: { __typename: 'Period', start: string | null, end: string | null } | null }> | null, address: { __typename: 'Address', type: AddressType | null, use: AddressUse | null, text: string | null, line: Array<string> | null, city: string | null, district: string | null, state: string | null, postalCode: string | null, country: string | null, period: { __typename: 'Period', start: string | null, end: string | null } | null } | null }> | null } & { ' $fragmentName'?: 'OrganizationFragment' };

export type ClaimFragment = { __typename: 'Claim', id: string | null, resourceType: string, meta: { __typename: 'Meta', versionId: string | null, tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, billablePeriod: { __typename: 'Period', start: string | null, end: string | null } | null, type: { __typename: 'CodeableConcept', coding: Array<(
      { __typename: 'Coding' }
      & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
    )> | null }, diagnosis: Array<{ __typename: 'ClaimDiagnosis', sequence: number, diagnosisCodeableConcept: { __typename: 'CodeableConcept', coding: Array<(
        { __typename: 'Coding' }
        & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
      )> | null } | null }> | null, item: Array<{ __typename: 'ClaimItem', sequence: number, productOrService: { __typename: 'CodeableConcept', coding: Array<(
        { __typename: 'Coding' }
        & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
      )> | null } }> | null } & { ' $fragmentName'?: 'ClaimFragment' };

export type CodeableConceptFragment = { __typename: 'CodeableConcept', text: string | null, coding: Array<(
    { __typename: 'Coding' }
    & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
  )> | null } & { ' $fragmentName'?: 'CodeableConceptFragment' };

export type EncounterFragment = { __typename: 'Encounter', id: string | null, resourceType: string, status: EncounterStatus, BasicList: Array<(
    { __typename: 'Basic' }
    & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
  )> | null, meta: { __typename: 'Meta', versionId: string | null, tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null, extension: Array<{ __typename: 'Extension', url: string, valueReference: { __typename: 'Reference', id: string | null, type: string | null, reference: string | null } | null }> | null }> | null, class: { __typename: 'Coding', system: string | null, version: string | null, code: string | null, display: string | null }, type: Array<(
    { __typename: 'CodeableConcept' }
    & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
  )> | null, serviceType: (
    { __typename: 'CodeableConcept' }
    & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
  ) | null, priority: (
    { __typename: 'CodeableConcept' }
    & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
  ) | null, diagnosis: Array<{ __typename: 'EncounterDiagnosis', condition: { __typename: 'Reference', reference: string | null, display: string | null, resource:
        | { __typename: 'Account' }
        | { __typename: 'AllergyIntolerance' }
        | { __typename: 'Appointment' }
        | { __typename: 'AppointmentResponse' }
        | { __typename: 'Basic' }
        | { __typename: 'Binary' }
        | { __typename: 'CarePlan' }
        | { __typename: 'CareTeam' }
        | { __typename: 'Claim' }
        | { __typename: 'ClaimResponse' }
        | { __typename: 'ClinicalImpression' }
        | { __typename: 'CommunicationRequest' }
        | { __typename: 'Composition' }
        | { __typename: 'Condition', code: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
              { __typename: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null } | null }
        | { __typename: 'Consent' }
        | { __typename: 'Contract' }
        | { __typename: 'Coverage' }
        | { __typename: 'CoverageEligibilityRequest' }
        | { __typename: 'DetectedIssue' }
        | { __typename: 'Device' }
        | { __typename: 'DeviceDefinition' }
        | { __typename: 'DeviceMetric' }
        | { __typename: 'DeviceRequest' }
        | { __typename: 'DeviceUseStatement' }
        | { __typename: 'DiagnosticReport' }
        | { __typename: 'DocumentReference' }
        | { __typename: 'Encounter' }
        | { __typename: 'Endpoint' }
        | { __typename: 'EpisodeOfCare' }
        | { __typename: 'FamilyMemberHistory' }
        | { __typename: 'Goal' }
        | { __typename: 'Group' }
        | { __typename: 'HealthcareService' }
        | { __typename: 'ImagingStudy' }
        | { __typename: 'Immunization' }
        | { __typename: 'ImmunizationEvaluation' }
        | { __typename: 'ImmunizationRecommendation' }
        | { __typename: 'InsurancePlan' }
        | { __typename: 'List' }
        | { __typename: 'Location' }
        | { __typename: 'Measure' }
        | { __typename: 'MeasureReport' }
        | { __typename: 'Media' }
        | { __typename: 'Medication' }
        | { __typename: 'MedicationAdministration' }
        | { __typename: 'MedicationDispense' }
        | { __typename: 'MedicationRequest' }
        | { __typename: 'MedicationStatement' }
        | { __typename: 'MolecularSequence' }
        | { __typename: 'NutritionOrder' }
        | { __typename: 'Observation' }
        | { __typename: 'Organization' }
        | { __typename: 'Patient' }
        | { __typename: 'PlanDefinition' }
        | { __typename: 'Practitioner' }
        | { __typename: 'PractitionerRole' }
        | { __typename: 'Procedure' }
        | { __typename: 'Provenance' }
        | { __typename: 'Questionnaire' }
        | { __typename: 'QuestionnaireResponse' }
        | { __typename: 'RelatedPerson' }
        | { __typename: 'RequestGroup' }
        | { __typename: 'ResearchStudy' }
        | { __typename: 'RiskAssessment' }
        | { __typename: 'Schedule' }
        | { __typename: 'ServiceRequest' }
        | { __typename: 'Slot' }
        | { __typename: 'Specimen' }
        | { __typename: 'Substance' }
        | { __typename: 'SupplyRequest' }
        | { __typename: 'Task' }
        | { __typename: 'VisionPrescription' }
       | null } }> | null, participant: Array<{ __typename: 'EncounterParticipant', individual: { __typename: 'Reference', reference: string | null, display: string | null, resource:
        | { __typename: 'Account' }
        | { __typename: 'AllergyIntolerance' }
        | { __typename: 'Appointment' }
        | { __typename: 'AppointmentResponse' }
        | { __typename: 'Basic' }
        | { __typename: 'Binary' }
        | { __typename: 'CarePlan' }
        | { __typename: 'CareTeam' }
        | { __typename: 'Claim' }
        | { __typename: 'ClaimResponse' }
        | { __typename: 'ClinicalImpression' }
        | { __typename: 'CommunicationRequest' }
        | { __typename: 'Composition' }
        | { __typename: 'Condition' }
        | { __typename: 'Consent' }
        | { __typename: 'Contract' }
        | { __typename: 'Coverage' }
        | { __typename: 'CoverageEligibilityRequest' }
        | { __typename: 'DetectedIssue' }
        | { __typename: 'Device' }
        | { __typename: 'DeviceDefinition' }
        | { __typename: 'DeviceMetric' }
        | { __typename: 'DeviceRequest' }
        | { __typename: 'DeviceUseStatement' }
        | { __typename: 'DiagnosticReport' }
        | { __typename: 'DocumentReference' }
        | { __typename: 'Encounter' }
        | { __typename: 'Endpoint' }
        | { __typename: 'EpisodeOfCare' }
        | { __typename: 'FamilyMemberHistory' }
        | { __typename: 'Goal' }
        | { __typename: 'Group' }
        | { __typename: 'HealthcareService' }
        | { __typename: 'ImagingStudy' }
        | { __typename: 'Immunization' }
        | { __typename: 'ImmunizationEvaluation' }
        | { __typename: 'ImmunizationRecommendation' }
        | { __typename: 'InsurancePlan' }
        | { __typename: 'List' }
        | { __typename: 'Location' }
        | { __typename: 'Measure' }
        | { __typename: 'MeasureReport' }
        | { __typename: 'Media' }
        | { __typename: 'Medication' }
        | { __typename: 'MedicationAdministration' }
        | { __typename: 'MedicationDispense' }
        | { __typename: 'MedicationRequest' }
        | { __typename: 'MedicationStatement' }
        | { __typename: 'MolecularSequence' }
        | { __typename: 'NutritionOrder' }
        | { __typename: 'Observation' }
        | { __typename: 'Organization' }
        | { __typename: 'Patient' }
        | { __typename: 'PlanDefinition' }
        | { __typename: 'Practitioner', name: Array<{ __typename: 'HumanName', family: string | null, given: Array<string> | null }> | null }
        | { __typename: 'PractitionerRole' }
        | { __typename: 'Procedure' }
        | { __typename: 'Provenance' }
        | { __typename: 'Questionnaire' }
        | { __typename: 'QuestionnaireResponse' }
        | { __typename: 'RelatedPerson' }
        | { __typename: 'RequestGroup' }
        | { __typename: 'ResearchStudy' }
        | { __typename: 'RiskAssessment' }
        | { __typename: 'Schedule' }
        | { __typename: 'ServiceRequest' }
        | { __typename: 'Slot' }
        | { __typename: 'Specimen' }
        | { __typename: 'Substance' }
        | { __typename: 'SupplyRequest' }
        | { __typename: 'Task' }
        | { __typename: 'VisionPrescription' }
       | null } | null, type: Array<(
      { __typename: 'CodeableConcept' }
      & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
    )> | null, period: { __typename: 'Period', start: string | null, end: string | null } | null }> | null, period: { __typename: 'Period', start: string | null, end: string | null } | null, ProvenanceList: Array<{ __typename: 'Provenance', id: string | null, entity: Array<{ __typename: 'ProvenanceEntity', what: (
        { __typename: 'Reference' }
        & { ' $fragmentRefs'?: { 'ReferenceFragment': ReferenceFragment } }
      ) }> | null }> | null, length: { __typename: 'Duration', value: number | null, unit: string | null } | null, reasonCode: Array<(
    { __typename: 'CodeableConcept' }
    & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
  )> | null, hospitalization: { __typename: 'EncounterHospitalization', dischargeDisposition: (
      { __typename: 'CodeableConcept' }
      & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
    ) | null } | null, location: Array<{ __typename: 'EncounterLocation', status: EncounterLocationStatus | null, location: { __typename: 'Reference', reference: string | null, display: string | null, resource:
        | { __typename: 'Account' }
        | { __typename: 'AllergyIntolerance' }
        | { __typename: 'Appointment' }
        | { __typename: 'AppointmentResponse' }
        | { __typename: 'Basic' }
        | { __typename: 'Binary' }
        | { __typename: 'CarePlan' }
        | { __typename: 'CareTeam' }
        | { __typename: 'Claim' }
        | { __typename: 'ClaimResponse' }
        | { __typename: 'ClinicalImpression' }
        | { __typename: 'CommunicationRequest' }
        | { __typename: 'Composition' }
        | { __typename: 'Condition' }
        | { __typename: 'Consent' }
        | { __typename: 'Contract' }
        | { __typename: 'Coverage' }
        | { __typename: 'CoverageEligibilityRequest' }
        | { __typename: 'DetectedIssue' }
        | { __typename: 'Device' }
        | { __typename: 'DeviceDefinition' }
        | { __typename: 'DeviceMetric' }
        | { __typename: 'DeviceRequest' }
        | { __typename: 'DeviceUseStatement' }
        | { __typename: 'DiagnosticReport' }
        | { __typename: 'DocumentReference' }
        | { __typename: 'Encounter' }
        | { __typename: 'Endpoint' }
        | { __typename: 'EpisodeOfCare' }
        | { __typename: 'FamilyMemberHistory' }
        | { __typename: 'Goal' }
        | { __typename: 'Group' }
        | { __typename: 'HealthcareService' }
        | { __typename: 'ImagingStudy' }
        | { __typename: 'Immunization' }
        | { __typename: 'ImmunizationEvaluation' }
        | { __typename: 'ImmunizationRecommendation' }
        | { __typename: 'InsurancePlan' }
        | { __typename: 'List' }
        | { __typename: 'Location', name: string | null, type: Array<(
            { __typename: 'CodeableConcept' }
            & { ' $fragmentRefs'?: { 'CodeableConceptFragment': CodeableConceptFragment } }
          )> | null }
        | { __typename: 'Measure' }
        | { __typename: 'MeasureReport' }
        | { __typename: 'Media' }
        | { __typename: 'Medication' }
        | { __typename: 'MedicationAdministration' }
        | { __typename: 'MedicationDispense' }
        | { __typename: 'MedicationRequest' }
        | { __typename: 'MedicationStatement' }
        | { __typename: 'MolecularSequence' }
        | { __typename: 'NutritionOrder' }
        | { __typename: 'Observation' }
        | { __typename: 'Organization' }
        | { __typename: 'Patient' }
        | { __typename: 'PlanDefinition' }
        | { __typename: 'Practitioner' }
        | { __typename: 'PractitionerRole' }
        | { __typename: 'Procedure' }
        | { __typename: 'Provenance' }
        | { __typename: 'Questionnaire' }
        | { __typename: 'QuestionnaireResponse' }
        | { __typename: 'RelatedPerson' }
        | { __typename: 'RequestGroup' }
        | { __typename: 'ResearchStudy' }
        | { __typename: 'RiskAssessment' }
        | { __typename: 'Schedule' }
        | { __typename: 'ServiceRequest' }
        | { __typename: 'Slot' }
        | { __typename: 'Specimen' }
        | { __typename: 'Substance' }
        | { __typename: 'SupplyRequest' }
        | { __typename: 'Task' }
        | { __typename: 'VisionPrescription' }
       | null }, period: { __typename: 'Period', start: string | null, end: string | null } | null }> | null } & { ' $fragmentName'?: 'EncounterFragment' };

export type EpisodeOfCareOverviewFragment = { __typename: 'EpisodeOfCare', id: string | null, resourceType: string, status: EpisodeOfCareStatus, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null, valueReference: { __typename: 'Reference', id: string | null, type: string | null, reference: string | null, display: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null, valueBoolean: boolean | null }> | null } | null }> | null, valueReference: { __typename: 'Reference', id: string | null, type: string | null, reference: string | null, display: string | null } | null, valueCodeableConcept: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', system: string | null, code: string | null, display: string | null }> | null } | null, valueCoding: { __typename: 'Coding', code: string | null, display: string | null, system: string | null, userSelected: boolean | null, version: string | null } | null }> | null, meta: { __typename: 'Meta', lastUpdated: string | null, extension: Array<{ __typename: 'Extension', url: string }> | null, security: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null, tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, period: { __typename: 'Period', start: string | null, end: string | null } | null } & { ' $fragmentName'?: 'EpisodeOfCareOverviewFragment' };

export type EpisodeOfCareFragment = { __typename: 'EpisodeOfCare', id: string | null, resourceType: string, status: EpisodeOfCareStatus, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null, valueReference: { __typename: 'Reference', id: string | null, type: string | null, reference: string | null, display: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null, valueBoolean: boolean | null }> | null, resource:
          | { __typename: 'Account' }
          | { __typename: 'AllergyIntolerance' }
          | { __typename: 'Appointment' }
          | { __typename: 'AppointmentResponse' }
          | { __typename: 'Basic' }
          | { __typename: 'Binary' }
          | { __typename: 'CarePlan' }
          | { __typename: 'CareTeam' }
          | { __typename: 'Claim' }
          | { __typename: 'ClaimResponse' }
          | { __typename: 'ClinicalImpression' }
          | { __typename: 'CommunicationRequest' }
          | { __typename: 'Composition' }
          | { __typename: 'Condition' }
          | { __typename: 'Consent' }
          | { __typename: 'Contract' }
          | { __typename: 'Coverage' }
          | { __typename: 'CoverageEligibilityRequest' }
          | { __typename: 'DetectedIssue' }
          | { __typename: 'Device' }
          | { __typename: 'DeviceDefinition' }
          | { __typename: 'DeviceMetric' }
          | { __typename: 'DeviceRequest' }
          | { __typename: 'DeviceUseStatement' }
          | { __typename: 'DiagnosticReport' }
          | { __typename: 'DocumentReference' }
          | (
            { __typename: 'Encounter' }
            & { ' $fragmentRefs'?: { 'EncounterFragment': EncounterFragment } }
          )
          | { __typename: 'Endpoint' }
          | { __typename: 'EpisodeOfCare' }
          | { __typename: 'FamilyMemberHistory' }
          | { __typename: 'Goal' }
          | { __typename: 'Group' }
          | { __typename: 'HealthcareService' }
          | { __typename: 'ImagingStudy' }
          | { __typename: 'Immunization' }
          | { __typename: 'ImmunizationEvaluation' }
          | { __typename: 'ImmunizationRecommendation' }
          | { __typename: 'InsurancePlan' }
          | { __typename: 'List' }
          | { __typename: 'Location' }
          | { __typename: 'Measure' }
          | { __typename: 'MeasureReport' }
          | { __typename: 'Media' }
          | { __typename: 'Medication' }
          | { __typename: 'MedicationAdministration' }
          | { __typename: 'MedicationDispense' }
          | { __typename: 'MedicationRequest' }
          | { __typename: 'MedicationStatement' }
          | { __typename: 'MolecularSequence' }
          | { __typename: 'NutritionOrder' }
          | { __typename: 'Observation' }
          | { __typename: 'Organization' }
          | { __typename: 'Patient' }
          | { __typename: 'PlanDefinition' }
          | { __typename: 'Practitioner' }
          | { __typename: 'PractitionerRole' }
          | { __typename: 'Procedure' }
          | { __typename: 'Provenance' }
          | { __typename: 'Questionnaire' }
          | { __typename: 'QuestionnaireResponse' }
          | { __typename: 'RelatedPerson' }
          | { __typename: 'RequestGroup' }
          | { __typename: 'ResearchStudy' }
          | { __typename: 'RiskAssessment' }
          | { __typename: 'Schedule' }
          | { __typename: 'ServiceRequest' }
          | { __typename: 'Slot' }
          | { __typename: 'Specimen' }
          | { __typename: 'Substance' }
          | { __typename: 'SupplyRequest' }
          | { __typename: 'Task' }
          | { __typename: 'VisionPrescription' }
         | null } | null }> | null, valueReference: { __typename: 'Reference', id: string | null, type: string | null, reference: string | null, display: string | null } | null, valueCodeableConcept: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', system: string | null, code: string | null, display: string | null }> | null } | null, valueCoding: { __typename: 'Coding', code: string | null, display: string | null, system: string | null, userSelected: boolean | null, version: string | null } | null }> | null, meta: { __typename: 'Meta', lastUpdated: string | null, extension: Array<{ __typename: 'Extension', url: string }> | null, security: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null, tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, period: { __typename: 'Period', start: string | null, end: string | null } | null, identifier: Array<{ __typename: 'Identifier', system: string | null, value: string | null, type: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', system: string | null, code: string | null, display: string | null }> | null } | null }> | null, diagnosis: Array<{ __typename: 'EpisodeOfCareDiagnosis', role: { __typename: 'CodeableConcept', coding: Array<{ __typename: 'Coding', system: string | null, code: string | null, display: string | null }> | null } | null, condition: { __typename: 'Reference', id: string | null, type: string | null, reference: string | null, resource:
        | { __typename: 'Account' }
        | { __typename: 'AllergyIntolerance' }
        | { __typename: 'Appointment' }
        | { __typename: 'AppointmentResponse' }
        | { __typename: 'Basic' }
        | { __typename: 'Binary' }
        | { __typename: 'CarePlan' }
        | { __typename: 'CareTeam' }
        | { __typename: 'Claim' }
        | { __typename: 'ClaimResponse' }
        | { __typename: 'ClinicalImpression' }
        | { __typename: 'CommunicationRequest' }
        | { __typename: 'Composition' }
        | { __typename: 'Condition', id: string | null, resourceType: string, code: { __typename: 'CodeableConcept', text: string | null, coding: Array<{ __typename: 'Coding', display: string | null, code: string | null, system: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null }> | null } | null }
        | { __typename: 'Consent' }
        | { __typename: 'Contract' }
        | { __typename: 'Coverage' }
        | { __typename: 'CoverageEligibilityRequest' }
        | { __typename: 'DetectedIssue' }
        | { __typename: 'Device' }
        | { __typename: 'DeviceDefinition' }
        | { __typename: 'DeviceMetric' }
        | { __typename: 'DeviceRequest' }
        | { __typename: 'DeviceUseStatement' }
        | { __typename: 'DiagnosticReport' }
        | { __typename: 'DocumentReference' }
        | { __typename: 'Encounter' }
        | { __typename: 'Endpoint' }
        | { __typename: 'EpisodeOfCare' }
        | { __typename: 'FamilyMemberHistory' }
        | { __typename: 'Goal' }
        | { __typename: 'Group' }
        | { __typename: 'HealthcareService' }
        | { __typename: 'ImagingStudy' }
        | { __typename: 'Immunization' }
        | { __typename: 'ImmunizationEvaluation' }
        | { __typename: 'ImmunizationRecommendation' }
        | { __typename: 'InsurancePlan' }
        | { __typename: 'List' }
        | { __typename: 'Location' }
        | { __typename: 'Measure' }
        | { __typename: 'MeasureReport' }
        | { __typename: 'Media' }
        | { __typename: 'Medication' }
        | { __typename: 'MedicationAdministration' }
        | { __typename: 'MedicationDispense' }
        | { __typename: 'MedicationRequest' }
        | { __typename: 'MedicationStatement' }
        | { __typename: 'MolecularSequence' }
        | { __typename: 'NutritionOrder' }
        | { __typename: 'Observation' }
        | { __typename: 'Organization' }
        | { __typename: 'Patient' }
        | { __typename: 'PlanDefinition' }
        | { __typename: 'Practitioner' }
        | { __typename: 'PractitionerRole' }
        | { __typename: 'Procedure' }
        | { __typename: 'Provenance' }
        | { __typename: 'Questionnaire' }
        | { __typename: 'QuestionnaireResponse' }
        | { __typename: 'RelatedPerson' }
        | { __typename: 'RequestGroup' }
        | { __typename: 'ResearchStudy' }
        | { __typename: 'RiskAssessment' }
        | { __typename: 'Schedule' }
        | { __typename: 'ServiceRequest' }
        | { __typename: 'Slot' }
        | { __typename: 'Specimen' }
        | { __typename: 'Substance' }
        | { __typename: 'SupplyRequest' }
        | { __typename: 'Task' }
        | { __typename: 'VisionPrescription' }
       | null } }> | null } & { ' $fragmentName'?: 'EpisodeOfCareFragment' };

export type ProcedureFragment = { __typename: 'Procedure', id: string | null, resourceType: string, status: EventStatus, performedDateTime: string | null, performedString: string | null, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null, extension: Array<{ __typename: 'Extension', url: string, valueReference: { __typename: 'Reference', reference: string | null } | null }> | null } | null, code: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
      { __typename: 'Coding' }
      & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
    )> | null } | null, category: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
      { __typename: 'Coding' }
      & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
    )> | null } | null, performedPeriod: { __typename: 'Period', start: string | null, end: string | null } | null, performedAge: { __typename: 'Age', value: number | null, unit: string | null } | null, performedRange: { __typename: 'Range', low: { __typename: 'Quantity', value: number | null, unit: string | null } | null, high: { __typename: 'Quantity', value: number | null, unit: string | null } | null } | null, performer: Array<{ __typename: 'ProcedurePerformer', actor: { __typename: 'Reference', display: string | null }, function: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
        { __typename: 'Coding' }
        & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
      )> | null } | null }> | null, bodySite: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<(
      { __typename: 'Coding' }
      & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
    )> | null }> | null, reasonCode: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<(
      { __typename: 'Coding' }
      & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
    )> | null }> | null, outcome: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
      { __typename: 'Coding' }
      & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
    )> | null } | null, ProvenanceList: Array<{ __typename: 'Provenance', id: string | null, target: Array<{ __typename: 'Reference', reference: string | null }>, entity: Array<{ __typename: 'ProvenanceEntity', role: ProvenanceEntityRole, what: (
        { __typename: 'Reference' }
        & { ' $fragmentRefs'?: { 'ReferenceFragment': ReferenceFragment } }
      ) }> | null }> | null } & { ' $fragmentName'?: 'ProcedureFragment' };

export type ImmunizationsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: ImmunizationSortParams;
  filter?: ImmunizationFilterParams;
  first: number;
}>;


export type ImmunizationsQuery = { __typename: 'Query', ImmunizationConnection: { __typename: 'ImmunizationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'ImmunizationEdge', node: { __typename: 'Immunization', id: string | null, resourceType: string, status: ImmunizationStatus, occurrenceDateTime: string | null, occurrenceString: string | null, recorded: string | null, lotNumber: string | null, expirationDate: string | null, BasicList: Array<(
          { __typename: 'Basic' }
          & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
        )> | null, meta: { __typename: 'Meta', versionId: string | null, tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, statusReason: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, vaccineCode: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }, patient: { __typename: 'Reference', reference: string | null, resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization' }
            | (
              { __typename: 'Patient', managingOrganization: { __typename: 'Reference', resource:
                  | { __typename: 'Account' }
                  | { __typename: 'AllergyIntolerance' }
                  | { __typename: 'Appointment' }
                  | { __typename: 'AppointmentResponse' }
                  | { __typename: 'Basic' }
                  | { __typename: 'Binary' }
                  | { __typename: 'CarePlan' }
                  | { __typename: 'CareTeam' }
                  | { __typename: 'Claim' }
                  | { __typename: 'ClaimResponse' }
                  | { __typename: 'ClinicalImpression' }
                  | { __typename: 'CommunicationRequest' }
                  | { __typename: 'Composition' }
                  | { __typename: 'Condition' }
                  | { __typename: 'Consent' }
                  | { __typename: 'Contract' }
                  | { __typename: 'Coverage' }
                  | { __typename: 'CoverageEligibilityRequest' }
                  | { __typename: 'DetectedIssue' }
                  | { __typename: 'Device' }
                  | { __typename: 'DeviceDefinition' }
                  | { __typename: 'DeviceMetric' }
                  | { __typename: 'DeviceRequest' }
                  | { __typename: 'DeviceUseStatement' }
                  | { __typename: 'DiagnosticReport' }
                  | { __typename: 'DocumentReference' }
                  | { __typename: 'Encounter' }
                  | { __typename: 'Endpoint' }
                  | { __typename: 'EpisodeOfCare' }
                  | { __typename: 'FamilyMemberHistory' }
                  | { __typename: 'Goal' }
                  | { __typename: 'Group' }
                  | { __typename: 'HealthcareService' }
                  | { __typename: 'ImagingStudy' }
                  | { __typename: 'Immunization' }
                  | { __typename: 'ImmunizationEvaluation' }
                  | { __typename: 'ImmunizationRecommendation' }
                  | { __typename: 'InsurancePlan' }
                  | { __typename: 'List' }
                  | { __typename: 'Location' }
                  | { __typename: 'Measure' }
                  | { __typename: 'MeasureReport' }
                  | { __typename: 'Media' }
                  | { __typename: 'Medication' }
                  | { __typename: 'MedicationAdministration' }
                  | { __typename: 'MedicationDispense' }
                  | { __typename: 'MedicationRequest' }
                  | { __typename: 'MedicationStatement' }
                  | { __typename: 'MolecularSequence' }
                  | { __typename: 'NutritionOrder' }
                  | { __typename: 'Observation' }
                  | { __typename: 'Organization', name: string | null }
                  | { __typename: 'Patient' }
                  | { __typename: 'PlanDefinition' }
                  | { __typename: 'Practitioner' }
                  | { __typename: 'PractitionerRole' }
                  | { __typename: 'Procedure' }
                  | { __typename: 'Provenance' }
                  | { __typename: 'Questionnaire' }
                  | { __typename: 'QuestionnaireResponse' }
                  | { __typename: 'RelatedPerson' }
                  | { __typename: 'RequestGroup' }
                  | { __typename: 'ResearchStudy' }
                  | { __typename: 'RiskAssessment' }
                  | { __typename: 'Schedule' }
                  | { __typename: 'ServiceRequest' }
                  | { __typename: 'Slot' }
                  | { __typename: 'Specimen' }
                  | { __typename: 'Substance' }
                  | { __typename: 'SupplyRequest' }
                  | { __typename: 'Task' }
                  | { __typename: 'VisionPrescription' }
                 | null } | null }
              & { ' $fragmentRefs'?: { 'PatientFragment': PatientFragment } }
            )
            | { __typename: 'PlanDefinition' }
            | { __typename: 'Practitioner' }
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null } } }> | null } | null };

export type MedicationAdministrationsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  filter: MedicationAdministrationFilterParams;
  sort: MedicationAdministrationSortParams;
  first: number;
}>;


export type MedicationAdministrationsQuery = { __typename: 'Query', MedicationAdministrationConnection: { __typename: 'MedicationAdministrationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'MedicationAdministrationEdge', node: { __typename: 'MedicationAdministration', id: string | null, resourceType: string, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, dosage: { __typename: 'MedicationAdministrationDosage', text: string | null, dose: { __typename: 'Quantity', value: number | null, unit: string | null } | null, route: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
              { __typename: 'Coding' }
              & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
            )> | null } | null } | null, effectivePeriod: { __typename: 'Period', start: string | null, end: string | null } | null } }> | null } | null };

export type MedicationDispensesQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  filter: MedicationDispenseFilterParams;
  sort: MedicationDispenseSortParams;
  first: number;
}>;


export type MedicationDispensesQuery = { __typename: 'Query', MedicationDispenseConnection: { __typename: 'MedicationDispenseConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'MedicationDispenseEdge', node: { __typename: 'MedicationDispense', id: string | null, resourceType: string, status: MedicationdispenseStatus, whenHandedOver: string | null, whenPrepared: string | null, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null, valueInstant: string | null }> | null, contained: Array<{ __typename: 'Resource', resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization', id: string | null, resourceType: string, _organization__name: string | null, telecom: Array<{ __typename: 'ContactPoint', value: string | null }> | null, address: Array<{ __typename: 'Address', city: string | null, state: string | null, postalCode: string | null, text: string | null, line: Array<string> | null }> | null }
            | { __typename: 'Patient' }
            | { __typename: 'PlanDefinition' }
            | { __typename: 'Practitioner', id: string | null, resourceType: string, name: Array<{ __typename: 'HumanName', family: string | null, given: Array<string> | null }> | null, address: Array<{ __typename: 'Address', text: string | null }> | null, telecom: Array<{ __typename: 'ContactPoint', value: string | null }> | null }
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null }> | null, performer: Array<{ __typename: 'MedicationDispensePerformer', actor: { __typename: 'Reference', id: string | null, reference: string | null, type: string | null, display: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, identifier: { __typename: 'Identifier', id: string | null, system: string | null, value: string | null } | null, resource:
              | { __typename: 'Account' }
              | { __typename: 'AllergyIntolerance' }
              | { __typename: 'Appointment' }
              | { __typename: 'AppointmentResponse' }
              | { __typename: 'Basic' }
              | { __typename: 'Binary' }
              | { __typename: 'CarePlan' }
              | { __typename: 'CareTeam' }
              | { __typename: 'Claim' }
              | { __typename: 'ClaimResponse' }
              | { __typename: 'ClinicalImpression' }
              | { __typename: 'CommunicationRequest' }
              | { __typename: 'Composition' }
              | { __typename: 'Condition' }
              | { __typename: 'Consent' }
              | { __typename: 'Contract' }
              | { __typename: 'Coverage' }
              | { __typename: 'CoverageEligibilityRequest' }
              | { __typename: 'DetectedIssue' }
              | { __typename: 'Device' }
              | { __typename: 'DeviceDefinition' }
              | { __typename: 'DeviceMetric' }
              | { __typename: 'DeviceRequest' }
              | { __typename: 'DeviceUseStatement' }
              | { __typename: 'DiagnosticReport' }
              | { __typename: 'DocumentReference' }
              | { __typename: 'Encounter' }
              | { __typename: 'Endpoint' }
              | { __typename: 'EpisodeOfCare' }
              | { __typename: 'FamilyMemberHistory' }
              | { __typename: 'Goal' }
              | { __typename: 'Group' }
              | { __typename: 'HealthcareService' }
              | { __typename: 'ImagingStudy' }
              | { __typename: 'Immunization' }
              | { __typename: 'ImmunizationEvaluation' }
              | { __typename: 'ImmunizationRecommendation' }
              | { __typename: 'InsurancePlan' }
              | { __typename: 'List' }
              | { __typename: 'Location' }
              | { __typename: 'Measure' }
              | { __typename: 'MeasureReport' }
              | { __typename: 'Media' }
              | { __typename: 'Medication' }
              | { __typename: 'MedicationAdministration' }
              | { __typename: 'MedicationDispense' }
              | { __typename: 'MedicationRequest' }
              | { __typename: 'MedicationStatement' }
              | { __typename: 'MolecularSequence' }
              | { __typename: 'NutritionOrder' }
              | { __typename: 'Observation' }
              | { __typename: 'Organization', id: string | null, resourceType: string, name: string | null, telecom: Array<{ __typename: 'ContactPoint', value: string | null }> | null, address: Array<{ __typename: 'Address', city: string | null, state: string | null, postalCode: string | null, text: string | null, line: Array<string> | null }> | null }
              | { __typename: 'Patient' }
              | { __typename: 'PlanDefinition' }
              | { __typename: 'Practitioner' }
              | { __typename: 'PractitionerRole' }
              | { __typename: 'Procedure' }
              | { __typename: 'Provenance' }
              | { __typename: 'Questionnaire' }
              | { __typename: 'QuestionnaireResponse' }
              | { __typename: 'RelatedPerson' }
              | { __typename: 'RequestGroup' }
              | { __typename: 'ResearchStudy' }
              | { __typename: 'RiskAssessment' }
              | { __typename: 'Schedule' }
              | { __typename: 'ServiceRequest' }
              | { __typename: 'Slot' }
              | { __typename: 'Specimen' }
              | { __typename: 'Substance' }
              | { __typename: 'SupplyRequest' }
              | { __typename: 'Task' }
              | { __typename: 'VisionPrescription' }
             | null } }> | null, quantity: { __typename: 'Quantity', value: number | null, unit: string | null } | null, medicationCodeableConcept: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, daysSupply: { __typename: 'Quantity', value: number | null, unit: string | null } | null } }> | null } | null };

export type MedicationRequestsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  filter: MedicationRequestFilterParams;
  sort: MedicationRequestSortParams;
  first: number;
}>;


export type MedicationRequestsQuery = { __typename: 'Query', MedicationRequestConnection: { __typename: 'MedicationRequestConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'MedicationRequestEdge', node: { __typename: 'MedicationRequest', id: string | null, resourceType: string, authoredOn: string | null, reportedBoolean: boolean | null, status: MedicationrequestStatus, meta: { __typename: 'Meta', tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, contained: Array<{ __typename: 'Resource', resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization', id: string | null, resourceType: string, _organization__name: string | null, telecom: Array<{ __typename: 'ContactPoint', value: string | null }> | null, address: Array<{ __typename: 'Address', city: string | null, state: string | null, postalCode: string | null, text: string | null, line: Array<string> | null }> | null }
            | { __typename: 'Patient' }
            | { __typename: 'PlanDefinition' }
            | { __typename: 'Practitioner', id: string | null, resourceType: string, name: Array<{ __typename: 'HumanName', family: string | null, given: Array<string> | null }> | null, address: Array<{ __typename: 'Address', text: string | null }> | null, telecom: Array<{ __typename: 'ContactPoint', value: string | null }> | null }
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null }> | null, dispenseRequest: { __typename: 'MedicationRequestDispenseRequest', numberOfRepeatsAllowed: number | null, performer: { __typename: 'Reference', id: string | null, reference: string | null, type: string | null, display: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, identifier: { __typename: 'Identifier', id: string | null, system: string | null, value: string | null } | null, resource:
              | { __typename: 'Account' }
              | { __typename: 'AllergyIntolerance' }
              | { __typename: 'Appointment' }
              | { __typename: 'AppointmentResponse' }
              | { __typename: 'Basic' }
              | { __typename: 'Binary' }
              | { __typename: 'CarePlan' }
              | { __typename: 'CareTeam' }
              | { __typename: 'Claim' }
              | { __typename: 'ClaimResponse' }
              | { __typename: 'ClinicalImpression' }
              | { __typename: 'CommunicationRequest' }
              | { __typename: 'Composition' }
              | { __typename: 'Condition' }
              | { __typename: 'Consent' }
              | { __typename: 'Contract' }
              | { __typename: 'Coverage' }
              | { __typename: 'CoverageEligibilityRequest' }
              | { __typename: 'DetectedIssue' }
              | { __typename: 'Device' }
              | { __typename: 'DeviceDefinition' }
              | { __typename: 'DeviceMetric' }
              | { __typename: 'DeviceRequest' }
              | { __typename: 'DeviceUseStatement' }
              | { __typename: 'DiagnosticReport' }
              | { __typename: 'DocumentReference' }
              | { __typename: 'Encounter' }
              | { __typename: 'Endpoint' }
              | { __typename: 'EpisodeOfCare' }
              | { __typename: 'FamilyMemberHistory' }
              | { __typename: 'Goal' }
              | { __typename: 'Group' }
              | { __typename: 'HealthcareService' }
              | { __typename: 'ImagingStudy' }
              | { __typename: 'Immunization' }
              | { __typename: 'ImmunizationEvaluation' }
              | { __typename: 'ImmunizationRecommendation' }
              | { __typename: 'InsurancePlan' }
              | { __typename: 'List' }
              | { __typename: 'Location' }
              | { __typename: 'Measure' }
              | { __typename: 'MeasureReport' }
              | { __typename: 'Media' }
              | { __typename: 'Medication' }
              | { __typename: 'MedicationAdministration' }
              | { __typename: 'MedicationDispense' }
              | { __typename: 'MedicationRequest' }
              | { __typename: 'MedicationStatement' }
              | { __typename: 'MolecularSequence' }
              | { __typename: 'NutritionOrder' }
              | { __typename: 'Observation' }
              | { __typename: 'Organization', id: string | null, resourceType: string, name: string | null, telecom: Array<{ __typename: 'ContactPoint', value: string | null }> | null, address: Array<{ __typename: 'Address', city: string | null, state: string | null, postalCode: string | null, text: string | null, line: Array<string> | null }> | null }
              | { __typename: 'Patient' }
              | { __typename: 'PlanDefinition' }
              | { __typename: 'Practitioner' }
              | { __typename: 'PractitionerRole' }
              | { __typename: 'Procedure' }
              | { __typename: 'Provenance' }
              | { __typename: 'Questionnaire' }
              | { __typename: 'QuestionnaireResponse' }
              | { __typename: 'RelatedPerson' }
              | { __typename: 'RequestGroup' }
              | { __typename: 'ResearchStudy' }
              | { __typename: 'RiskAssessment' }
              | { __typename: 'Schedule' }
              | { __typename: 'ServiceRequest' }
              | { __typename: 'Slot' }
              | { __typename: 'Specimen' }
              | { __typename: 'Substance' }
              | { __typename: 'SupplyRequest' }
              | { __typename: 'Task' }
              | { __typename: 'VisionPrescription' }
             | null } | null, initialFill: { __typename: 'MedicationRequestDispenseRequestInitialFill', quantity: { __typename: 'Quantity', value: number | null, unit: string | null } | null } | null } | null, dosageInstruction: Array<{ __typename: 'Dosage', text: string | null, timing: { __typename: 'Timing', repeat: { __typename: 'TimingRepeat', boundsPeriod: { __typename: 'Period', start: string | null } | null } | null } | null }> | null, medicationCodeableConcept: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, performer: (
          { __typename: 'Reference' }
          & { ' $fragmentRefs'?: { 'ReferenceFragment': ReferenceFragment } }
        ) | null, requester: { __typename: 'Reference', id: string | null, reference: string | null, type: string | null, display: string | null, extension: Array<{ __typename: 'Extension', url: string, valueString: string | null }> | null, identifier: { __typename: 'Identifier', id: string | null, system: string | null, value: string | null } | null, resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization' }
            | { __typename: 'Patient' }
            | { __typename: 'PlanDefinition' }
            | { __typename: 'Practitioner', id: string | null, resourceType: string, name: Array<{ __typename: 'HumanName', family: string | null, given: Array<string> | null }> | null, address: Array<{ __typename: 'Address', text: string | null }> | null, telecom: Array<{ __typename: 'ContactPoint', value: string | null }> | null }
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null } | null } }> | null } | null };

export type MedicationStatementsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  filter: MedicationStatementFilterParams;
  sort: MedicationStatementSortParams;
  first: number;
}>;


export type MedicationStatementsQuery = { __typename: 'Query', MedicationStatementConnection: { __typename: 'MedicationStatementConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'MedicationStatementEdge', node: { __typename: 'MedicationStatement', id: string | null, resourceType: string, dateAsserted: string | null, status: MedicationStatementStatus, BasicList: Array<(
          { __typename: 'Basic' }
          & { ' $fragmentRefs'?: { 'BasicFragment': BasicFragment } }
        )> | null, meta: { __typename: 'Meta', versionId: string | null, tag: Array<{ __typename: 'Coding', system: string | null, code: string | null }> | null } | null, extension: Array<{ __typename: 'Extension', url: string, valueDateTime: string | null, valueString: string | null, valueUnsignedInt: number | null, extension: Array<{ __typename: 'Extension', url: string, valueReference: { __typename: 'Reference', id: string | null, type: string | null, reference: string | null } | null }> | null, valueReference: { __typename: 'Reference', id: string | null, type: string | null, reference: string | null, display: string | null } | null, valueQuantity: { __typename: 'Quantity', unit: string | null, value: number | null } | null }> | null, basedOn: Array<{ __typename: 'Reference', type: string | null }> | null, category: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, contained: Array<{ __typename: 'Resource', resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication', id: string | null, resourceType: string, code: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
                  { __typename: 'Coding' }
                  & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
                )> | null } | null }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization', id: string | null, resourceType: string, _organization__name: string | null }
            | { __typename: 'Patient' }
            | { __typename: 'PlanDefinition' }
            | { __typename: 'Practitioner', id: string | null, resourceType: string, name: Array<{ __typename: 'HumanName', family: string | null, given: Array<string> | null }> | null }
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null }> | null, context: { __typename: 'Reference', display: string | null } | null, derivedFrom: Array<(
          { __typename: 'Reference' }
          & { ' $fragmentRefs'?: { 'ReferenceFragment': ReferenceFragment } }
        )> | null, dosage: Array<{ __typename: 'Dosage', text: string | null }> | null, effectivePeriod: { __typename: 'Period', start: string | null } | null, identifier: Array<{ __typename: 'Identifier', value: string | null }> | null, informationSource: { __typename: 'Reference', type: string | null } | null, medicationCodeableConcept: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null } | null, medicationReference: { __typename: 'Reference', display: string | null } | null, note: Array<{ __typename: 'Annotation', text: string }> | null, partOf: Array<{ __typename: 'Reference', display: string | null }> | null, reasonCode: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, reasonReference: Array<(
          { __typename: 'Reference' }
          & { ' $fragmentRefs'?: { 'ReferenceFragment': ReferenceFragment } }
        )> | null, statusReason: Array<{ __typename: 'CodeableConcept', text: string | null, coding: Array<(
            { __typename: 'Coding' }
            & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
          )> | null }> | null, subject: { __typename: 'Reference', resource:
            | { __typename: 'Account' }
            | { __typename: 'AllergyIntolerance' }
            | { __typename: 'Appointment' }
            | { __typename: 'AppointmentResponse' }
            | { __typename: 'Basic' }
            | { __typename: 'Binary' }
            | { __typename: 'CarePlan' }
            | { __typename: 'CareTeam' }
            | { __typename: 'Claim' }
            | { __typename: 'ClaimResponse' }
            | { __typename: 'ClinicalImpression' }
            | { __typename: 'CommunicationRequest' }
            | { __typename: 'Composition' }
            | { __typename: 'Condition' }
            | { __typename: 'Consent' }
            | { __typename: 'Contract' }
            | { __typename: 'Coverage' }
            | { __typename: 'CoverageEligibilityRequest' }
            | { __typename: 'DetectedIssue' }
            | { __typename: 'Device' }
            | { __typename: 'DeviceDefinition' }
            | { __typename: 'DeviceMetric' }
            | { __typename: 'DeviceRequest' }
            | { __typename: 'DeviceUseStatement' }
            | { __typename: 'DiagnosticReport' }
            | { __typename: 'DocumentReference' }
            | { __typename: 'Encounter' }
            | { __typename: 'Endpoint' }
            | { __typename: 'EpisodeOfCare' }
            | { __typename: 'FamilyMemberHistory' }
            | { __typename: 'Goal' }
            | { __typename: 'Group' }
            | { __typename: 'HealthcareService' }
            | { __typename: 'ImagingStudy' }
            | { __typename: 'Immunization' }
            | { __typename: 'ImmunizationEvaluation' }
            | { __typename: 'ImmunizationRecommendation' }
            | { __typename: 'InsurancePlan' }
            | { __typename: 'List' }
            | { __typename: 'Location' }
            | { __typename: 'Measure' }
            | { __typename: 'MeasureReport' }
            | { __typename: 'Media' }
            | { __typename: 'Medication' }
            | { __typename: 'MedicationAdministration' }
            | { __typename: 'MedicationDispense' }
            | { __typename: 'MedicationRequest' }
            | { __typename: 'MedicationStatement' }
            | { __typename: 'MolecularSequence' }
            | { __typename: 'NutritionOrder' }
            | { __typename: 'Observation' }
            | { __typename: 'Organization' }
            | { __typename: 'Patient', managingOrganization: { __typename: 'Reference', resource:
                  | { __typename: 'Account' }
                  | { __typename: 'AllergyIntolerance' }
                  | { __typename: 'Appointment' }
                  | { __typename: 'AppointmentResponse' }
                  | { __typename: 'Basic' }
                  | { __typename: 'Binary' }
                  | { __typename: 'CarePlan' }
                  | { __typename: 'CareTeam' }
                  | { __typename: 'Claim' }
                  | { __typename: 'ClaimResponse' }
                  | { __typename: 'ClinicalImpression' }
                  | { __typename: 'CommunicationRequest' }
                  | { __typename: 'Composition' }
                  | { __typename: 'Condition' }
                  | { __typename: 'Consent' }
                  | { __typename: 'Contract' }
                  | { __typename: 'Coverage' }
                  | { __typename: 'CoverageEligibilityRequest' }
                  | { __typename: 'DetectedIssue' }
                  | { __typename: 'Device' }
                  | { __typename: 'DeviceDefinition' }
                  | { __typename: 'DeviceMetric' }
                  | { __typename: 'DeviceRequest' }
                  | { __typename: 'DeviceUseStatement' }
                  | { __typename: 'DiagnosticReport' }
                  | { __typename: 'DocumentReference' }
                  | { __typename: 'Encounter' }
                  | { __typename: 'Endpoint' }
                  | { __typename: 'EpisodeOfCare' }
                  | { __typename: 'FamilyMemberHistory' }
                  | { __typename: 'Goal' }
                  | { __typename: 'Group' }
                  | { __typename: 'HealthcareService' }
                  | { __typename: 'ImagingStudy' }
                  | { __typename: 'Immunization' }
                  | { __typename: 'ImmunizationEvaluation' }
                  | { __typename: 'ImmunizationRecommendation' }
                  | { __typename: 'InsurancePlan' }
                  | { __typename: 'List' }
                  | { __typename: 'Location' }
                  | { __typename: 'Measure' }
                  | { __typename: 'MeasureReport' }
                  | { __typename: 'Media' }
                  | { __typename: 'Medication' }
                  | { __typename: 'MedicationAdministration' }
                  | { __typename: 'MedicationDispense' }
                  | { __typename: 'MedicationRequest' }
                  | { __typename: 'MedicationStatement' }
                  | { __typename: 'MolecularSequence' }
                  | { __typename: 'NutritionOrder' }
                  | { __typename: 'Observation' }
                  | { __typename: 'Organization', name: string | null }
                  | { __typename: 'Patient' }
                  | { __typename: 'PlanDefinition' }
                  | { __typename: 'Practitioner' }
                  | { __typename: 'PractitionerRole' }
                  | { __typename: 'Procedure' }
                  | { __typename: 'Provenance' }
                  | { __typename: 'Questionnaire' }
                  | { __typename: 'QuestionnaireResponse' }
                  | { __typename: 'RelatedPerson' }
                  | { __typename: 'RequestGroup' }
                  | { __typename: 'ResearchStudy' }
                  | { __typename: 'RiskAssessment' }
                  | { __typename: 'Schedule' }
                  | { __typename: 'ServiceRequest' }
                  | { __typename: 'Slot' }
                  | { __typename: 'Specimen' }
                  | { __typename: 'Substance' }
                  | { __typename: 'SupplyRequest' }
                  | { __typename: 'Task' }
                  | { __typename: 'VisionPrescription' }
                 | null } | null }
            | { __typename: 'PlanDefinition' }
            | { __typename: 'Practitioner' }
            | { __typename: 'PractitionerRole' }
            | { __typename: 'Procedure' }
            | { __typename: 'Provenance' }
            | { __typename: 'Questionnaire' }
            | { __typename: 'QuestionnaireResponse' }
            | { __typename: 'RelatedPerson' }
            | { __typename: 'RequestGroup' }
            | { __typename: 'ResearchStudy' }
            | { __typename: 'RiskAssessment' }
            | { __typename: 'Schedule' }
            | { __typename: 'ServiceRequest' }
            | { __typename: 'Slot' }
            | { __typename: 'Specimen' }
            | { __typename: 'Substance' }
            | { __typename: 'SupplyRequest' }
            | { __typename: 'Task' }
            | { __typename: 'VisionPrescription' }
           | null } } }> | null } | null };

export type ObservationsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: ObservationSortParams;
  filter: ObservationFilterParams;
  first: number;
}>;


export type ObservationsQuery = { __typename: 'Query', ObservationConnection: { __typename: 'ObservationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'ObservationEdge', node: (
        { __typename: 'Observation' }
        & { ' $fragmentRefs'?: { 'ObservationFragment': ObservationFragment } }
      ) }> | null } | null };

export type ObservationsLiteQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: ObservationSortParams;
  filter: ObservationFilterParams;
  first: number;
}>;


export type ObservationsLiteQuery = { __typename: 'Query', ObservationConnection: { __typename: 'ObservationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'ObservationEdge', node: (
        { __typename: 'Observation' }
        & { ' $fragmentRefs'?: { 'ObservationLiteFragment': ObservationLiteFragment } }
      ) }> | null } | null };

export type PatientsForUpidQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: PatientSortParams;
  first: number;
  filter?: PatientFilterParams;
}>;


export type PatientsForUpidQuery = { __typename: 'Query', PatientConnection: { __typename: 'PatientConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'PatientEdge', node: (
        { __typename: 'Patient' }
        & { ' $fragmentRefs'?: { 'PatientFragment': PatientFragment } }
      ) }> | null } | null };

export type PatientsForBuilderQueryVariables = Exact<{
  builderID: string | number;
  cursor: string;
  first: number;
  filter?: PatientFilterParams;
}>;


export type PatientsForBuilderQuery = { __typename: 'Query', PatientConnection: { __typename: 'PatientConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'PatientEdge', node: (
        { __typename: 'Patient' }
        & { ' $fragmentRefs'?: { 'PatientListItemFragment': PatientListItemFragment } }
      ) }> | null } | null };

export type ProceduresQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: ProcedureSortParams;
  filter: ProcedureFilterParams;
  first: number;
}>;


export type ProceduresQuery = { __typename: 'Query', ProcedureConnection: { __typename: 'ProcedureConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'ProcedureEdge', node: (
        { __typename: 'Procedure' }
        & { ' $fragmentRefs'?: { 'ProcedureFragment': ProcedureFragment } }
      ) }> | null } | null };

export type PatientRecordSearchQueryVariables = Exact<{
  upid: string | number;
  query: string;
  resourceTypes?: Array<string> | string | null | undefined;
}>;


export type PatientRecordSearchQuery = { __typename: 'Query', SearchConnection: { __typename: 'ZapSearchConnection', edges: Array<{ __typename: 'ZapSearchEdge', node: { __typename: 'ZapSearchResult', id: string, resourceType: string, score: number, title: string | null, resource:
          | { __typename: 'Account' }
          | { __typename: 'AllergyIntolerance' }
          | { __typename: 'Appointment' }
          | { __typename: 'AppointmentResponse' }
          | { __typename: 'Basic' }
          | { __typename: 'Binary', id: string | null, resourceType: string }
          | { __typename: 'CarePlan' }
          | { __typename: 'CareTeam' }
          | { __typename: 'Claim' }
          | { __typename: 'ClaimResponse' }
          | { __typename: 'ClinicalImpression' }
          | { __typename: 'CommunicationRequest' }
          | { __typename: 'Composition' }
          | { __typename: 'Condition' }
          | { __typename: 'Consent' }
          | { __typename: 'Contract' }
          | { __typename: 'Coverage' }
          | { __typename: 'CoverageEligibilityRequest' }
          | { __typename: 'DetectedIssue' }
          | { __typename: 'Device' }
          | { __typename: 'DeviceDefinition' }
          | { __typename: 'DeviceMetric' }
          | { __typename: 'DeviceRequest' }
          | { __typename: 'DeviceUseStatement' }
          | { __typename: 'DiagnosticReport', id: string | null, resourceType: string, effectiveDateTime: string | null, issued: string | null, code: { __typename: 'CodeableConcept', text: string | null, coding: Array<(
                { __typename: 'Coding' }
                & { ' $fragmentRefs'?: { 'CodingFragment': CodingFragment } }
              )> | null }, effectivePeriod: { __typename: 'Period', start: string | null } | null, result: Array<{ __typename: 'Reference', reference: string | null, display: string | null }> | null }
          | { __typename: 'DocumentReference' }
          | { __typename: 'Encounter' }
          | { __typename: 'Endpoint' }
          | { __typename: 'EpisodeOfCare' }
          | { __typename: 'FamilyMemberHistory' }
          | { __typename: 'Goal' }
          | { __typename: 'Group' }
          | { __typename: 'HealthcareService' }
          | { __typename: 'ImagingStudy' }
          | { __typename: 'Immunization' }
          | { __typename: 'ImmunizationEvaluation' }
          | { __typename: 'ImmunizationRecommendation' }
          | { __typename: 'InsurancePlan' }
          | { __typename: 'List' }
          | { __typename: 'Location' }
          | { __typename: 'Measure' }
          | { __typename: 'MeasureReport' }
          | { __typename: 'Media' }
          | { __typename: 'Medication' }
          | { __typename: 'MedicationAdministration' }
          | { __typename: 'MedicationDispense' }
          | { __typename: 'MedicationRequest' }
          | { __typename: 'MedicationStatement' }
          | { __typename: 'MolecularSequence' }
          | { __typename: 'NutritionOrder' }
          | { __typename: 'Observation' }
          | { __typename: 'Organization' }
          | { __typename: 'Patient' }
          | { __typename: 'PlanDefinition' }
          | { __typename: 'Practitioner' }
          | { __typename: 'PractitionerRole' }
          | { __typename: 'Procedure' }
          | { __typename: 'Provenance' }
          | { __typename: 'Questionnaire' }
          | { __typename: 'QuestionnaireResponse' }
          | { __typename: 'RelatedPerson' }
          | { __typename: 'RequestGroup' }
          | { __typename: 'ResearchStudy' }
          | { __typename: 'RiskAssessment' }
          | { __typename: 'Schedule' }
          | { __typename: 'ServiceRequest' }
          | { __typename: 'Slot' }
          | { __typename: 'Specimen' }
          | { __typename: 'Substance' }
          | { __typename: 'SupplyRequest' }
          | { __typename: 'Task' }
          | { __typename: 'VisionPrescription' }
        , matches: Array<{ __typename: 'SearchContext', location: string, text: string, term: string }> } }> } | null };

export type ServiceRequestsQueryVariables = Exact<{
  upid: string | number;
  cursor: string;
  sort: ServiceRequestSortParams;
  filter?: ServiceRequestFilterParams;
  first: number;
}>;


export type ServiceRequestsQuery = { __typename: 'Query', ServiceRequestConnection: { __typename: 'ServiceRequestConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename: 'ServiceRequestEdge', node: (
        { __typename: 'ServiceRequest' }
        & { ' $fragmentRefs'?: { 'ServiceRequestFragment': ServiceRequestFragment } }
      ) }> | null } | null };

export type PatientUpiRecordTypeTagStatusQueryVariables = Exact<{
  upid: string | number;
  tag: string;
}>;


export type PatientUpiRecordTypeTagStatusQuery = { __typename: 'Query', taggedPatients: { __typename: 'PatientConnection', edges: Array<{ __typename: 'PatientEdge', node: { __typename: 'Patient', id: string | null } }> | null } | null, allPatients: { __typename: 'PatientConnection', edges: Array<{ __typename: 'PatientEdge', node: { __typename: 'Patient', id: string | null } }> | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ConditionFragmentDoc = new TypedDocumentString(`
    fragment Condition on Condition {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    text
    coding {
      __typename
      system
      code
      display
    }
  }
}
    `, {"fragmentName":"Condition"}) as unknown as TypedDocumentString<ConditionFragment, unknown>;
export const BasicFragmentDoc = new TypedDocumentString(`
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
    `, {"fragmentName":"Basic"}) as unknown as TypedDocumentString<BasicFragment, unknown>;
export const CodingFragmentDoc = new TypedDocumentString(`
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
    `, {"fragmentName":"Coding"}) as unknown as TypedDocumentString<CodingFragment, unknown>;
export const DiagnosticReportOverviewFragmentDoc = new TypedDocumentString(`
    fragment DiagnosticReportOverview on DiagnosticReport {
  __typename
  id
  resourceType
  BasicList(_reference: "subject") {
    __typename
    ...Basic
  }
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
    extension {
      __typename
      url
      valueInstant
    }
  }
  code {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  effectiveDateTime
  effectivePeriod {
    __typename
    start
  }
  issued
  performer {
    __typename
    reference
    display
  }
  subject {
    __typename
    reference
  }
  result {
    __typename
    reference
    display
  }
}
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`, {"fragmentName":"DiagnosticReportOverview"}) as unknown as TypedDocumentString<DiagnosticReportOverviewFragment, unknown>;
export const DocumentFragmentDoc = new TypedDocumentString(`
    fragment Document on DocumentReference {
  __typename
  id
  resourceType
  masterIdentifier {
    __typename
    system
    use
    value
  }
  meta {
    __typename
    extension {
      __typename
      url
      valueInstant
    }
    tag {
      __typename
      system
      code
    }
    versionId
  }
  extension {
    __typename
    url
    valueString
  }
  status
  docStatus
  type {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  text {
    __typename
    id
    div
  }
  category {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  date
  subject {
    __typename
    reference
    display
  }
  author {
    __typename
    reference
    display
  }
  custodian {
    __typename
    reference
    display
  }
  description
  content {
    __typename
    attachment {
      __typename
      contentType
      language
      data
      url
      size
      hash
      title
      creation
    }
    format {
      __typename
      system
      version
      code
      display
    }
  }
  context {
    __typename
    period {
      __typename
      start
      end
    }
    encounter {
      __typename
      reference
    }
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`, {"fragmentName":"Document"}) as unknown as TypedDocumentString<DocumentFragment, unknown>;
export const DocumentWithBasicsFragmentDoc = new TypedDocumentString(`
    fragment DocumentWithBasics on DocumentReference {
  __typename
  ...Document
  BasicList(_reference: "subject") {
    __typename
    ...Basic
  }
}
    fragment Document on DocumentReference {
  __typename
  id
  resourceType
  masterIdentifier {
    __typename
    system
    use
    value
  }
  meta {
    __typename
    extension {
      __typename
      url
      valueInstant
    }
    tag {
      __typename
      system
      code
    }
    versionId
  }
  extension {
    __typename
    url
    valueString
  }
  status
  docStatus
  type {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  text {
    __typename
    id
    div
  }
  category {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  date
  subject {
    __typename
    reference
    display
  }
  author {
    __typename
    reference
    display
  }
  custodian {
    __typename
    reference
    display
  }
  description
  content {
    __typename
    attachment {
      __typename
      contentType
      language
      data
      url
      size
      hash
      title
      creation
    }
    format {
      __typename
      system
      version
      code
      display
    }
  }
  context {
    __typename
    period {
      __typename
      start
      end
    }
    encounter {
      __typename
      reference
    }
  }
}
fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`, {"fragmentName":"DocumentWithBasics"}) as unknown as TypedDocumentString<DocumentWithBasicsFragment, unknown>;
export const EncounterReferenceFragmentDoc = new TypedDocumentString(`
    fragment EncounterReference on Encounter {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  status
  priority {
    __typename
    text
    coding {
      __typename
      code
      display
      system
    }
  }
}
    `, {"fragmentName":"EncounterReference"}) as unknown as TypedDocumentString<EncounterReferenceFragment, unknown>;
export const PractitionerFragmentDoc = new TypedDocumentString(`
    fragment Practitioner on Practitioner {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    use
  }
  qualification {
    __typename
    code {
      __typename
      text
      coding {
        __typename
        code
        display
        system
      }
    }
    period {
      __typename
      start
      end
    }
  }
}
    `, {"fragmentName":"Practitioner"}) as unknown as TypedDocumentString<PractitionerFragment, unknown>;
export const ServiceRequestFragmentDoc = new TypedDocumentString(`
    fragment ServiceRequest on ServiceRequest {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  status
  intent
  subject {
    __typename
    reference
  }
  identifier {
    __typename
    system
    value
  }
  requester {
    __typename
    resource {
      __typename
      ... on Practitioner {
        __typename
        id
        resourceType
        extension {
          __typename
          url
          valueString
        }
        name {
          __typename
          family
          given
          prefix
          suffix
          text
          use
        }
        qualification {
          __typename
          code {
            __typename
            text
            coding {
              __typename
              code
              display
              system
            }
          }
          period {
            __typename
            start
            end
          }
        }
      }
    }
    reference
    identifier {
      __typename
      system
      value
    }
    display
  }
  reasonCode {
    __typename
    text
  }
  authoredOn
  category {
    __typename
    text
  }
  performer {
    __typename
    reference
    identifier {
      __typename
      system
      value
    }
    display
  }
  locationReference {
    __typename
    reference
    display
  }
}
    `, {"fragmentName":"ServiceRequest"}) as unknown as TypedDocumentString<ServiceRequestFragment, unknown>;
export const AppointmentFragmentDoc = new TypedDocumentString(`
    fragment Appointment on Appointment {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  status
  participant {
    __typename
    actor {
      __typename
      reference
      identifier {
        __typename
        system
        value
      }
      display
    }
    status
  }
  basedOn {
    __typename
    reference
  }
  start
  end
  serviceType {
    __typename
    text
  }
  appointmentType {
    __typename
    text
  }
  serviceCategory {
    __typename
    text
  }
  specialty {
    __typename
    text
  }
}
    `, {"fragmentName":"Appointment"}) as unknown as TypedDocumentString<AppointmentFragment, unknown>;
export const OrganizationFragmentDoc = new TypedDocumentString(`
    fragment Organization on Organization {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  name
  telecom {
    __typename
    system
    value
    period {
      __typename
      start
      end
    }
  }
  contact {
    __typename
    purpose {
      __typename
      text
      coding {
        __typename
        code
        display
        system
        extension {
          __typename
          url
          valueString
        }
      }
    }
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      __typename
      system
      value
      period {
        __typename
        start
        end
      }
    }
    address {
      __typename
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        __typename
        start
        end
      }
    }
  }
}
    `, {"fragmentName":"Organization"}) as unknown as TypedDocumentString<OrganizationFragment, unknown>;
export const PatientFragmentDoc = new TypedDocumentString(`
    fragment Patient on Patient {
  __typename
  id
  resourceType
  meta {
    __typename
    versionId
    extension {
      __typename
      url
      valueString
      valueInstant
    }
    tag {
      __typename
      system
      code
    }
  }
  active
  identifier {
    __typename
    use
    system
    value
  }
  contact {
    __typename
    address {
      __typename
      city
      country
      district
      line
      period {
        __typename
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      __typename
      display
      identifier {
        __typename
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    __typename
    text
    coding {
      __typename
      code
      display
      system
    }
  }
  telecom {
    __typename
    use
    value
    system
  }
  address {
    __typename
    city
    country
    district
    line
    period {
      __typename
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    period {
      __typename
      start
      end
    }
    use
  }
  managingOrganization {
    __typename
    resource {
      __typename
      ...Organization
    }
  }
}
    fragment Organization on Organization {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  name
  telecom {
    __typename
    system
    value
    period {
      __typename
      start
      end
    }
  }
  contact {
    __typename
    purpose {
      __typename
      text
      coding {
        __typename
        code
        display
        system
        extension {
          __typename
          url
          valueString
        }
      }
    }
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      __typename
      system
      value
      period {
        __typename
        start
        end
      }
    }
    address {
      __typename
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        __typename
        start
        end
      }
    }
  }
}`, {"fragmentName":"Patient"}) as unknown as TypedDocumentString<PatientFragment, unknown>;
export const PatientListItemFragmentDoc = new TypedDocumentString(`
    fragment PatientListItem on Patient {
  __typename
  id
  resourceType
  meta {
    __typename
    versionId
    lastUpdated
    extension {
      __typename
      url
      valueString
      valueInstant
    }
  }
  extension {
    __typename
    url
    valueString
  }
  identifier {
    __typename
    use
    system
    value
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    period {
      __typename
      start
      end
    }
    use
  }
  birthDate
  gender
  telecom {
    __typename
    use
    value
    system
  }
}
    `, {"fragmentName":"PatientListItem"}) as unknown as TypedDocumentString<PatientListItemFragment, unknown>;
export const ObservationLiteFragmentDoc = new TypedDocumentString(`
    fragment ObservationLite on Observation {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  effectivePeriod {
    __typename
    start
  }
  effectiveDateTime
  referenceRange {
    __typename
    text
  }
  code {
    __typename
    text
    coding {
      __typename
      code
      display
      system
      extension {
        __typename
        url
        valueString
      }
    }
  }
  valueQuantity {
    __typename
    comparator
    unit
    value
    system
    code
  }
  valueCodeableConcept {
    __typename
    text
    coding {
      __typename
      system
      code
      display
    }
  }
  valueString
  valueBoolean
  valueInteger
  valueRange {
    __typename
    low {
      __typename
      unit
      value
      system
      code
    }
    high {
      __typename
      unit
      value
      system
      code
    }
  }
  valueTime
  valueDateTime
  valuePeriod {
    __typename
    start
    end
  }
  interpretation {
    __typename
    text
    coding {
      __typename
      code
      display
      system
      extension {
        __typename
        url
        valueString
      }
    }
  }
  note {
    __typename
    text
  }
}
    `, {"fragmentName":"ObservationLite"}) as unknown as TypedDocumentString<ObservationLiteFragment, unknown>;
export const ReferenceFragmentDoc = new TypedDocumentString(`
    fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}
    `, {"fragmentName":"Reference"}) as unknown as TypedDocumentString<ReferenceFragment, unknown>;
export const ObservationFragmentDoc = new TypedDocumentString(`
    fragment Observation on Observation {
  __typename
  id
  resourceType
  extension {
    __typename
    url
    valueString
  }
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  encounter {
    __typename
    reference
  }
  status
  category {
    __typename
    text
    coding {
      __typename
      code
      display
      system
      extension {
        __typename
        url
        valueString
      }
    }
  }
  effectivePeriod {
    __typename
    start
    end
  }
  effectiveDateTime
  referenceRange {
    __typename
    text
  }
  code {
    __typename
    text
    coding {
      __typename
      code
      display
      system
      extension {
        __typename
        url
        valueString
      }
    }
  }
  component {
    __typename
    code {
      __typename
      text
      coding {
        __typename
        code
        display
        system
      }
    }
    valueQuantity {
      __typename
      unit
      value
    }
    valueString
  }
  ProvenanceList(_reference: "target") {
    __typename
    id
    entity {
      __typename
      what {
        __typename
        ...Reference
      }
    }
  }
  valueQuantity {
    __typename
    comparator
    unit
    value
    system
    code
  }
  valueCodeableConcept {
    __typename
    text
    coding {
      __typename
      system
      code
      display
    }
  }
  valueString
  valueBoolean
  valueInteger
  valueRange {
    __typename
    low {
      __typename
      unit
      value
      system
      code
    }
    high {
      __typename
      unit
      value
      system
      code
    }
  }
  valueRatio {
    __typename
    numerator {
      __typename
      comparator
      unit
      value
      system
      code
    }
    denominator {
      __typename
      unit
      value
      system
      code
    }
  }
  valueTime
  valueDateTime
  valuePeriod {
    __typename
    start
    end
  }
  interpretation {
    __typename
    text
    coding {
      __typename
      code
      display
      system
      extension {
        __typename
        url
        valueString
      }
    }
  }
  subject {
    __typename
    resource {
      __typename
      ... on Patient {
        __typename
        managingOrganization {
          __typename
          resource {
            __typename
            ... on Organization {
              __typename
              name
            }
          }
        }
      }
    }
  }
  note {
    __typename
    text
  }
}
    fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}`, {"fragmentName":"Observation"}) as unknown as TypedDocumentString<ObservationFragment, unknown>;
export const ClaimFragmentDoc = new TypedDocumentString(`
    fragment Claim on Claim {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
    versionId
  }
  billablePeriod {
    __typename
    start
    end
  }
  type {
    __typename
    coding {
      __typename
      ...Coding
    }
  }
  diagnosis {
    __typename
    sequence
    diagnosisCodeableConcept {
      __typename
      coding {
        __typename
        ...Coding
      }
    }
  }
  item {
    __typename
    sequence
    productOrService {
      __typename
      coding {
        __typename
        ...Coding
      }
    }
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`, {"fragmentName":"Claim"}) as unknown as TypedDocumentString<ClaimFragment, unknown>;
export const EpisodeOfCareOverviewFragmentDoc = new TypedDocumentString(`
    fragment EpisodeOfCareOverview on EpisodeOfCare {
  __typename
  id
  resourceType
  extension {
    __typename
    url
    extension {
      __typename
      url
      valueReference {
        __typename
        id
        type
        reference
        display
        extension {
          __typename
          url
          valueString
          valueBoolean
        }
      }
      valueString
    }
    valueString
    valueReference {
      __typename
      id
      type
      reference
      display
    }
    valueCodeableConcept {
      __typename
      coding {
        __typename
        system
        code
        display
      }
      text
    }
    valueCoding {
      __typename
      code
      display
      system
      userSelected
      version
    }
  }
  meta {
    __typename
    extension {
      __typename
      url
    }
    security {
      __typename
      system
      code
    }
    tag {
      __typename
      system
      code
    }
    lastUpdated
  }
  period {
    __typename
    start
    end
  }
  status
}
    `, {"fragmentName":"EpisodeOfCareOverview"}) as unknown as TypedDocumentString<EpisodeOfCareOverviewFragment, unknown>;
export const CodeableConceptFragmentDoc = new TypedDocumentString(`
    fragment CodeableConcept on CodeableConcept {
  __typename
  text
  coding {
    __typename
    ...Coding
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`, {"fragmentName":"CodeableConcept"}) as unknown as TypedDocumentString<CodeableConceptFragment, unknown>;
export const EncounterFragmentDoc = new TypedDocumentString(`
    fragment Encounter on Encounter {
  __typename
  id
  resourceType
  BasicList(_reference: "subject") {
    __typename
    ...Basic
  }
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
    versionId
  }
  extension {
    __typename
    url
    valueString
    extension {
      __typename
      url
      valueReference {
        __typename
        id
        type
        reference
      }
    }
  }
  status
  class {
    __typename
    system
    version
    code
    display
  }
  type {
    __typename
    ...CodeableConcept
  }
  serviceType {
    __typename
    ...CodeableConcept
  }
  priority {
    __typename
    ...CodeableConcept
  }
  diagnosis {
    __typename
    condition {
      __typename
      reference
      display
      resource {
        __typename
        ... on Condition {
          __typename
          code {
            __typename
            coding {
              __typename
              ...Coding
            }
            text
          }
        }
      }
    }
  }
  participant {
    __typename
    individual {
      __typename
      reference
      resource {
        __typename
        ... on Practitioner {
          __typename
          name {
            __typename
            family
            given
          }
        }
      }
      display
    }
    type {
      __typename
      ...CodeableConcept
    }
    period {
      __typename
      start
      end
    }
  }
  period {
    __typename
    start
    end
  }
  ProvenanceList(_reference: "target") {
    __typename
    id
    entity {
      __typename
      what {
        __typename
        ...Reference
      }
    }
  }
  length {
    __typename
    value
    unit
  }
  reasonCode {
    __typename
    ...CodeableConcept
  }
  hospitalization {
    __typename
    dischargeDisposition {
      __typename
      ...CodeableConcept
    }
  }
  location {
    __typename
    location {
      __typename
      reference
      display
      resource {
        __typename
        ... on Location {
          __typename
          name
          type {
            __typename
            ...CodeableConcept
          }
        }
      }
    }
    status
    period {
      __typename
      start
      end
    }
  }
}
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}
fragment CodeableConcept on CodeableConcept {
  __typename
  text
  coding {
    __typename
    ...Coding
  }
}`, {"fragmentName":"Encounter"}) as unknown as TypedDocumentString<EncounterFragment, unknown>;
export const EpisodeOfCareFragmentDoc = new TypedDocumentString(`
    fragment EpisodeOfCare on EpisodeOfCare {
  __typename
  id
  resourceType
  extension {
    __typename
    url
    extension {
      __typename
      url
      valueReference {
        __typename
        id
        type
        reference
        display
        extension {
          __typename
          url
          valueString
          valueBoolean
        }
        resource {
          __typename
          ... on Encounter {
            __typename
            ...Encounter
          }
        }
      }
      valueString
    }
    valueString
    valueReference {
      __typename
      id
      type
      reference
      display
    }
    valueCodeableConcept {
      __typename
      coding {
        __typename
        system
        code
        display
      }
      text
    }
    valueCoding {
      __typename
      code
      display
      system
      userSelected
      version
    }
  }
  meta {
    __typename
    extension {
      __typename
      url
    }
    security {
      __typename
      system
      code
    }
    tag {
      __typename
      system
      code
    }
    lastUpdated
  }
  period {
    __typename
    start
    end
  }
  identifier {
    __typename
    system
    value
    type {
      __typename
      text
      coding {
        __typename
        system
        code
        display
      }
    }
  }
  status
  diagnosis {
    __typename
    role {
      __typename
      coding {
        __typename
        system
        code
        display
      }
    }
    condition {
      __typename
      id
      type
      reference
      resource {
        __typename
        ... on Condition {
          __typename
          id
          resourceType
          code {
            __typename
            text
            coding {
              __typename
              display
              code
              system
              extension {
                __typename
                url
                valueString
              }
            }
          }
        }
      }
    }
  }
}
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}
fragment CodeableConcept on CodeableConcept {
  __typename
  text
  coding {
    __typename
    ...Coding
  }
}
fragment Encounter on Encounter {
  __typename
  id
  resourceType
  BasicList(_reference: "subject") {
    __typename
    ...Basic
  }
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
    versionId
  }
  extension {
    __typename
    url
    valueString
    extension {
      __typename
      url
      valueReference {
        __typename
        id
        type
        reference
      }
    }
  }
  status
  class {
    __typename
    system
    version
    code
    display
  }
  type {
    __typename
    ...CodeableConcept
  }
  serviceType {
    __typename
    ...CodeableConcept
  }
  priority {
    __typename
    ...CodeableConcept
  }
  diagnosis {
    __typename
    condition {
      __typename
      reference
      display
      resource {
        __typename
        ... on Condition {
          __typename
          code {
            __typename
            coding {
              __typename
              ...Coding
            }
            text
          }
        }
      }
    }
  }
  participant {
    __typename
    individual {
      __typename
      reference
      resource {
        __typename
        ... on Practitioner {
          __typename
          name {
            __typename
            family
            given
          }
        }
      }
      display
    }
    type {
      __typename
      ...CodeableConcept
    }
    period {
      __typename
      start
      end
    }
  }
  period {
    __typename
    start
    end
  }
  ProvenanceList(_reference: "target") {
    __typename
    id
    entity {
      __typename
      what {
        __typename
        ...Reference
      }
    }
  }
  length {
    __typename
    value
    unit
  }
  reasonCode {
    __typename
    ...CodeableConcept
  }
  hospitalization {
    __typename
    dischargeDisposition {
      __typename
      ...CodeableConcept
    }
  }
  location {
    __typename
    location {
      __typename
      reference
      display
      resource {
        __typename
        ... on Location {
          __typename
          name
          type {
            __typename
            ...CodeableConcept
          }
        }
      }
    }
    status
    period {
      __typename
      start
      end
    }
  }
}`, {"fragmentName":"EpisodeOfCare"}) as unknown as TypedDocumentString<EpisodeOfCareFragment, unknown>;
export const ProcedureFragmentDoc = new TypedDocumentString(`
    fragment Procedure on Procedure {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
    extension {
      __typename
      url
      valueReference {
        __typename
        reference
      }
    }
  }
  status
  code {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  category {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  performedDateTime
  performedPeriod {
    __typename
    start
    end
  }
  performedString
  performedAge {
    __typename
    value
    unit
  }
  performedRange {
    __typename
    low {
      __typename
      value
      unit
    }
    high {
      __typename
      value
      unit
    }
  }
  performer {
    __typename
    actor {
      __typename
      display
    }
    function {
      __typename
      text
      coding {
        __typename
        ...Coding
      }
    }
  }
  bodySite {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  reasonCode {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  outcome {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  ProvenanceList(_reference: "target") {
    __typename
    id
    target {
      __typename
      reference
    }
    entity {
      __typename
      role
      what {
        __typename
        ...Reference
      }
    }
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}`, {"fragmentName":"Procedure"}) as unknown as TypedDocumentString<ProcedureFragment, unknown>;
export const TransitionOfCareLensQueryDocument = new TypedDocumentString(`
    query TransitionOfCareLensQuery($id: ID!) {
  __typename
  EpisodeOfCare(id: $id) {
    __typename
    ...EpisodeOfCare
    patient {
      __typename
      resource {
        __typename
        ... on Patient {
          __typename
          id
          resourceType
          name {
            __typename
            family
            given
          }
          identifier {
            __typename
            system
            value
            assigner {
              __typename
              display
            }
          }
          gender
          birthDate
        }
      }
    }
  }
}
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}
fragment CodeableConcept on CodeableConcept {
  __typename
  text
  coding {
    __typename
    ...Coding
  }
}
fragment Encounter on Encounter {
  __typename
  id
  resourceType
  BasicList(_reference: "subject") {
    __typename
    ...Basic
  }
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
    versionId
  }
  extension {
    __typename
    url
    valueString
    extension {
      __typename
      url
      valueReference {
        __typename
        id
        type
        reference
      }
    }
  }
  status
  class {
    __typename
    system
    version
    code
    display
  }
  type {
    __typename
    ...CodeableConcept
  }
  serviceType {
    __typename
    ...CodeableConcept
  }
  priority {
    __typename
    ...CodeableConcept
  }
  diagnosis {
    __typename
    condition {
      __typename
      reference
      display
      resource {
        __typename
        ... on Condition {
          __typename
          code {
            __typename
            coding {
              __typename
              ...Coding
            }
            text
          }
        }
      }
    }
  }
  participant {
    __typename
    individual {
      __typename
      reference
      resource {
        __typename
        ... on Practitioner {
          __typename
          name {
            __typename
            family
            given
          }
        }
      }
      display
    }
    type {
      __typename
      ...CodeableConcept
    }
    period {
      __typename
      start
      end
    }
  }
  period {
    __typename
    start
    end
  }
  ProvenanceList(_reference: "target") {
    __typename
    id
    entity {
      __typename
      what {
        __typename
        ...Reference
      }
    }
  }
  length {
    __typename
    value
    unit
  }
  reasonCode {
    __typename
    ...CodeableConcept
  }
  hospitalization {
    __typename
    dischargeDisposition {
      __typename
      ...CodeableConcept
    }
  }
  location {
    __typename
    location {
      __typename
      reference
      display
      resource {
        __typename
        ... on Location {
          __typename
          name
          type {
            __typename
            ...CodeableConcept
          }
        }
      }
    }
    status
    period {
      __typename
      start
      end
    }
  }
}
fragment EpisodeOfCare on EpisodeOfCare {
  __typename
  id
  resourceType
  extension {
    __typename
    url
    extension {
      __typename
      url
      valueReference {
        __typename
        id
        type
        reference
        display
        extension {
          __typename
          url
          valueString
          valueBoolean
        }
        resource {
          __typename
          ... on Encounter {
            __typename
            ...Encounter
          }
        }
      }
      valueString
    }
    valueString
    valueReference {
      __typename
      id
      type
      reference
      display
    }
    valueCodeableConcept {
      __typename
      coding {
        __typename
        system
        code
        display
      }
      text
    }
    valueCoding {
      __typename
      code
      display
      system
      userSelected
      version
    }
  }
  meta {
    __typename
    extension {
      __typename
      url
    }
    security {
      __typename
      system
      code
    }
    tag {
      __typename
      system
      code
    }
    lastUpdated
  }
  period {
    __typename
    start
    end
  }
  identifier {
    __typename
    system
    value
    type {
      __typename
      text
      coding {
        __typename
        system
        code
        display
      }
    }
  }
  status
  diagnosis {
    __typename
    role {
      __typename
      coding {
        __typename
        system
        code
        display
      }
    }
    condition {
      __typename
      id
      type
      reference
      resource {
        __typename
        ... on Condition {
          __typename
          id
          resourceType
          code {
            __typename
            text
            coding {
              __typename
              display
              code
              system
              extension {
                __typename
                url
                valueString
              }
            }
          }
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<TransitionOfCareLensQueryQuery, TransitionOfCareLensQueryQueryVariables>;
export const AllergiesDocument = new TypedDocumentString(`
    query Allergies($upid: ID!, $cursor: String!, $sort: AllergyIntoleranceSortParams!, $filter: AllergyIntoleranceFilterParams! = {}, $first: Int!) {
  __typename
  AllergyIntoleranceConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    filter: $filter
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        id
        resourceType
        BasicList(_reference: "subject") {
          __typename
          ...Basic
        }
        meta {
          __typename
          tag {
            __typename
            system
            code
            display
          }
        }
        clinicalStatus {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        extension {
          __typename
          url
          valueString
        }
        verificationStatus {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        type
        category
        criticality
        code {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        patient {
          __typename
          reference
          resource {
            __typename
            ... on Patient {
              __typename
              ...Patient
              managingOrganization {
                __typename
                resource {
                  __typename
                  ... on Organization {
                    __typename
                    name
                  }
                }
              }
            }
          }
        }
        encounter {
          __typename
          reference
          resource {
            __typename
            ...EncounterReference
          }
        }
        onsetDateTime
        onsetAge {
          __typename
          value
          unit
          system
          code
        }
        onsetPeriod {
          __typename
          start
          end
        }
        recordedDate
        recorder {
          __typename
          reference
          resource {
            __typename
            ...Practitioner
          }
        }
        lastOccurrence
        note {
          __typename
          text
          time
        }
        reaction {
          __typename
          substance {
            __typename
            text
            coding {
              __typename
              ...Coding
            }
          }
          manifestation {
            __typename
            text
            coding {
              __typename
              ...Coding
            }
          }
          onset
          severity
          note {
            __typename
            text
            time
          }
        }
      }
    }
  }
}
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment EncounterReference on Encounter {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  status
  priority {
    __typename
    text
    coding {
      __typename
      code
      display
      system
    }
  }
}
fragment Practitioner on Practitioner {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    use
  }
  qualification {
    __typename
    code {
      __typename
      text
      coding {
        __typename
        code
        display
        system
      }
    }
    period {
      __typename
      start
      end
    }
  }
}
fragment Patient on Patient {
  __typename
  id
  resourceType
  meta {
    __typename
    versionId
    extension {
      __typename
      url
      valueString
      valueInstant
    }
    tag {
      __typename
      system
      code
    }
  }
  active
  identifier {
    __typename
    use
    system
    value
  }
  contact {
    __typename
    address {
      __typename
      city
      country
      district
      line
      period {
        __typename
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      __typename
      display
      identifier {
        __typename
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    __typename
    text
    coding {
      __typename
      code
      display
      system
    }
  }
  telecom {
    __typename
    use
    value
    system
  }
  address {
    __typename
    city
    country
    district
    line
    period {
      __typename
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    period {
      __typename
      start
      end
    }
    use
  }
  managingOrganization {
    __typename
    resource {
      __typename
      ...Organization
    }
  }
}
fragment Organization on Organization {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  name
  telecom {
    __typename
    system
    value
    period {
      __typename
      start
      end
    }
  }
  contact {
    __typename
    purpose {
      __typename
      text
      coding {
        __typename
        code
        display
        system
        extension {
          __typename
          url
          valueString
        }
      }
    }
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      __typename
      system
      value
      period {
        __typename
        start
        end
      }
    }
    address {
      __typename
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        __typename
        start
        end
      }
    }
  }
}`) as unknown as TypedDocumentString<AllergiesQuery, AllergiesQueryVariables>;
export const AppointmentsDocument = new TypedDocumentString(`
    query Appointments($upid: ID!) {
  __typename
  AppointmentConnection(upid: $upid) {
    __typename
    edges {
      __typename
      node {
        __typename
        ...Appointment
      }
    }
  }
}
    fragment Appointment on Appointment {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  status
  participant {
    __typename
    actor {
      __typename
      reference
      identifier {
        __typename
        system
        value
      }
      display
    }
    status
  }
  basedOn {
    __typename
    reference
  }
  start
  end
  serviceType {
    __typename
    text
  }
  appointmentType {
    __typename
    text
  }
  serviceCategory {
    __typename
    text
  }
  specialty {
    __typename
    text
  }
}`) as unknown as TypedDocumentString<AppointmentsQuery, AppointmentsQueryVariables>;
export const CareTeamsDocument = new TypedDocumentString(`
    query CareTeams($upid: ID!, $cursor: String!, $sort: CareTeamSortParams!, $filter: CareTeamFilterParams! = {}, $first: Int!) {
  __typename
  CareTeamConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    filter: $filter
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        id
        resourceType
        meta {
          __typename
          extension {
            __typename
            url
            valueInstant
          }
          tag {
            __typename
            system
            code
          }
          versionId
        }
        extension {
          __typename
          url
          valueString
        }
        status
        category {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        name
        period {
          __typename
          start
          end
        }
        participant {
          __typename
          role {
            __typename
            text
            coding {
              __typename
              ...Coding
            }
          }
          member {
            __typename
            reference
            resource {
              __typename
              ...Practitioner
            }
          }
          onBehalfOf {
            __typename
            reference
          }
        }
        reasonCode {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        telecom {
          __typename
          system
          value
          use
          period {
            __typename
            start
            end
          }
        }
        note {
          __typename
          text
        }
      }
    }
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Practitioner on Practitioner {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    use
  }
  qualification {
    __typename
    code {
      __typename
      text
      coding {
        __typename
        code
        display
        system
      }
    }
    period {
      __typename
      start
      end
    }
  }
}`) as unknown as TypedDocumentString<CareTeamsQuery, CareTeamsQueryVariables>;
export const ClaimsDocument = new TypedDocumentString(`
    query Claims($upid: ID!, $cursor: String!, $filter: ClaimFilterParams! = {}, $sort: ClaimSortParams!, $first: Int!) {
  __typename
  ClaimConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        ...Claim
      }
    }
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Claim on Claim {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
    versionId
  }
  billablePeriod {
    __typename
    start
    end
  }
  type {
    __typename
    coding {
      __typename
      ...Coding
    }
  }
  diagnosis {
    __typename
    sequence
    diagnosisCodeableConcept {
      __typename
      coding {
        __typename
        ...Coding
      }
    }
  }
  item {
    __typename
    sequence
    productOrService {
      __typename
      coding {
        __typename
        ...Coding
      }
    }
  }
}`) as unknown as TypedDocumentString<ClaimsQuery, ClaimsQueryVariables>;
export const ConditionsDocument = new TypedDocumentString(`
    query Conditions($upid: ID!, $cursor: String!, $filter: ConditionFilterParams! = {}, $sort: ConditionSortParams!, $first: Int!) {
  __typename
  ConditionConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        ...Condition
      }
    }
  }
}
    fragment Condition on Condition {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    text
    coding {
      __typename
      system
      code
      display
    }
  }
}`) as unknown as TypedDocumentString<ConditionsQuery, ConditionsQueryVariables>;
export const FirstPartyConditionsDocument = new TypedDocumentString(`
    query FirstPartyConditions($upid: ID!, $cursor: String!, $filter: ConditionFilterParams! = {}, $sort: ConditionSortParams!, $first: Int!) {
  __typename
  ConditionConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        ...Condition
      }
    }
  }
}
    fragment Condition on Condition {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    text
    coding {
      __typename
      system
      code
      display
    }
  }
}`) as unknown as TypedDocumentString<FirstPartyConditionsQuery, FirstPartyConditionsQueryVariables>;
export const CoverageDocument = new TypedDocumentString(`
    query Coverage($upid: ID!, $cursor: String!, $filter: CoverageFilterParams! = {}, $sort: CoverageSortParams!, $first: Int!) {
  __typename
  CoverageConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        id
        resourceType
        meta {
          __typename
          lastUpdated
          extension {
            __typename
            url
            valueReference {
              __typename
              reference
            }
          }
          tag {
            __typename
            system
            code
          }
        }
        beneficiary {
          __typename
          reference
        }
        class {
          __typename
          type {
            __typename
            text
            coding {
              __typename
              ...Coding
            }
          }
          value
          name
        }
        order
        period {
          __typename
          start
        }
        status
        type {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        payor {
          __typename
          display
        }
        relationship {
          __typename
          coding {
            __typename
            ...Coding
          }
        }
        subscriberId
        subscriber {
          __typename
          reference
          resource {
            __typename
            ...Patient
          }
        }
      }
    }
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Patient on Patient {
  __typename
  id
  resourceType
  meta {
    __typename
    versionId
    extension {
      __typename
      url
      valueString
      valueInstant
    }
    tag {
      __typename
      system
      code
    }
  }
  active
  identifier {
    __typename
    use
    system
    value
  }
  contact {
    __typename
    address {
      __typename
      city
      country
      district
      line
      period {
        __typename
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      __typename
      display
      identifier {
        __typename
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    __typename
    text
    coding {
      __typename
      code
      display
      system
    }
  }
  telecom {
    __typename
    use
    value
    system
  }
  address {
    __typename
    city
    country
    district
    line
    period {
      __typename
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    period {
      __typename
      start
      end
    }
    use
  }
  managingOrganization {
    __typename
    resource {
      __typename
      ...Organization
    }
  }
}
fragment Organization on Organization {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  name
  telecom {
    __typename
    system
    value
    period {
      __typename
      start
      end
    }
  }
  contact {
    __typename
    purpose {
      __typename
      text
      coding {
        __typename
        code
        display
        system
        extension {
          __typename
          url
          valueString
        }
      }
    }
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      __typename
      system
      value
      period {
        __typename
        start
        end
      }
    }
    address {
      __typename
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        __typename
        start
        end
      }
    }
  }
}`) as unknown as TypedDocumentString<CoverageQuery, CoverageQueryVariables>;
export const DiagnosticReportsOverviewDocument = new TypedDocumentString(`
    query DiagnosticReportsOverview($upid: ID!, $cursor: String!, $sort: DiagnosticReportSortParams!, $filter: DiagnosticReportFilterParams!, $first: Int!) {
  __typename
  DiagnosticReportConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
      total
    }
    edges {
      __typename
      node {
        __typename
        ...DiagnosticReportOverview
      }
    }
  }
}
    fragment DiagnosticReportOverview on DiagnosticReport {
  __typename
  id
  resourceType
  BasicList(_reference: "subject") {
    __typename
    ...Basic
  }
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
    extension {
      __typename
      url
      valueInstant
    }
  }
  code {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  effectiveDateTime
  effectivePeriod {
    __typename
    start
  }
  issued
  performer {
    __typename
    reference
    display
  }
  subject {
    __typename
    reference
  }
  result {
    __typename
    reference
    display
  }
}
fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`) as unknown as TypedDocumentString<DiagnosticReportsOverviewQuery, DiagnosticReportsOverviewQueryVariables>;
export const DiagnosticReportsCursorDocument = new TypedDocumentString(`
    query DiagnosticReportsCursor($upid: ID!, $cursor: String!, $sort: DiagnosticReportSortParams!, $filter: DiagnosticReportFilterParams!, $first: Int!) {
  __typename
  DiagnosticReportConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DiagnosticReportsCursorQuery, DiagnosticReportsCursorQueryVariables>;
export const DiagnosticReportsDocument = new TypedDocumentString(`
    query DiagnosticReports($upid: ID!, $cursor: String!, $sort: DiagnosticReportSortParams!, $filter: DiagnosticReportFilterParams!, $first: Int!) {
  __typename
  DiagnosticReportConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        id
        resourceType
        BasicList(_reference: "subject") {
          __typename
          ...Basic
        }
        meta {
          __typename
          tag {
            __typename
            system
            code
          }
          extension {
            __typename
            url
            valueInstant
          }
        }
        extension {
          __typename
          url
          valueString
        }
        status
        category {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        code {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        effectiveDateTime
        effectivePeriod {
          __typename
          start
          end
        }
        issued
        conclusion
        performer {
          __typename
          reference
          resource {
            __typename
            ...Practitioner
          }
        }
        subject {
          __typename
          reference
          resource {
            __typename
            ...Patient
          }
        }
        result {
          __typename
          reference
          display
        }
      }
    }
  }
}
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Practitioner on Practitioner {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    use
  }
  qualification {
    __typename
    code {
      __typename
      text
      coding {
        __typename
        code
        display
        system
      }
    }
    period {
      __typename
      start
      end
    }
  }
}
fragment Patient on Patient {
  __typename
  id
  resourceType
  meta {
    __typename
    versionId
    extension {
      __typename
      url
      valueString
      valueInstant
    }
    tag {
      __typename
      system
      code
    }
  }
  active
  identifier {
    __typename
    use
    system
    value
  }
  contact {
    __typename
    address {
      __typename
      city
      country
      district
      line
      period {
        __typename
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      __typename
      display
      identifier {
        __typename
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    __typename
    text
    coding {
      __typename
      code
      display
      system
    }
  }
  telecom {
    __typename
    use
    value
    system
  }
  address {
    __typename
    city
    country
    district
    line
    period {
      __typename
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    period {
      __typename
      start
      end
    }
    use
  }
  managingOrganization {
    __typename
    resource {
      __typename
      ...Organization
    }
  }
}
fragment Organization on Organization {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  name
  telecom {
    __typename
    system
    value
    period {
      __typename
      start
      end
    }
  }
  contact {
    __typename
    purpose {
      __typename
      text
      coding {
        __typename
        code
        display
        system
        extension {
          __typename
          url
          valueString
        }
      }
    }
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      __typename
      system
      value
      period {
        __typename
        start
        end
      }
    }
    address {
      __typename
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        __typename
        start
        end
      }
    }
  }
}`) as unknown as TypedDocumentString<DiagnosticReportsQuery, DiagnosticReportsQueryVariables>;
export const DocumentReferencesWithBasicsDocument = new TypedDocumentString(`
    query DocumentReferencesWithBasics($upid: ID!, $cursor: String!, $sort: DocumentReferenceSortParams!, $filter: DocumentReferenceFilterParams! = {}, $first: Int!) {
  __typename
  DocumentReferenceConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    filter: $filter
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        ...DocumentWithBasics
      }
    }
  }
}
    fragment Document on DocumentReference {
  __typename
  id
  resourceType
  masterIdentifier {
    __typename
    system
    use
    value
  }
  meta {
    __typename
    extension {
      __typename
      url
      valueInstant
    }
    tag {
      __typename
      system
      code
    }
    versionId
  }
  extension {
    __typename
    url
    valueString
  }
  status
  docStatus
  type {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  text {
    __typename
    id
    div
  }
  category {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  date
  subject {
    __typename
    reference
    display
  }
  author {
    __typename
    reference
    display
  }
  custodian {
    __typename
    reference
    display
  }
  description
  content {
    __typename
    attachment {
      __typename
      contentType
      language
      data
      url
      size
      hash
      title
      creation
    }
    format {
      __typename
      system
      version
      code
      display
    }
  }
  context {
    __typename
    period {
      __typename
      start
      end
    }
    encounter {
      __typename
      reference
    }
  }
}
fragment DocumentWithBasics on DocumentReference {
  __typename
  ...Document
  BasicList(_reference: "subject") {
    __typename
    ...Basic
  }
}
fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`) as unknown as TypedDocumentString<DocumentReferencesWithBasicsQuery, DocumentReferencesWithBasicsQueryVariables>;
export const DocumentReferencesDocument = new TypedDocumentString(`
    query DocumentReferences($upid: ID!, $cursor: String!, $sort: DocumentReferenceSortParams!, $filter: DocumentReferenceFilterParams! = {}, $first: Int!) {
  __typename
  DocumentReferenceConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    filter: $filter
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        ...Document
      }
    }
  }
}
    fragment Document on DocumentReference {
  __typename
  id
  resourceType
  masterIdentifier {
    __typename
    system
    use
    value
  }
  meta {
    __typename
    extension {
      __typename
      url
      valueInstant
    }
    tag {
      __typename
      system
      code
    }
    versionId
  }
  extension {
    __typename
    url
    valueString
  }
  status
  docStatus
  type {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  text {
    __typename
    id
    div
  }
  category {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  date
  subject {
    __typename
    reference
    display
  }
  author {
    __typename
    reference
    display
  }
  custodian {
    __typename
    reference
    display
  }
  description
  content {
    __typename
    attachment {
      __typename
      contentType
      language
      data
      url
      size
      hash
      title
      creation
    }
    format {
      __typename
      system
      version
      code
      display
    }
  }
  context {
    __typename
    period {
      __typename
      start
      end
    }
    encounter {
      __typename
      reference
    }
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`) as unknown as TypedDocumentString<DocumentReferencesQuery, DocumentReferencesQueryVariables>;
export const DocumentReferencesListDocument = new TypedDocumentString(`
    query DocumentReferencesList($upid: ID!, $cursor: String!, $sort: DocumentReferenceSortParams!, $filter: DocumentReferenceFilterParams! = {}, $first: Int!) {
  __typename
  DocumentReferenceConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    filter: $filter
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        id
        resourceType
        BasicList(_reference: "subject") {
          __typename
          ...Basic
        }
        masterIdentifier {
          __typename
          system
          use
          value
        }
        meta {
          __typename
          tag {
            __typename
            system
            code
          }
        }
        extension {
          __typename
          url
          valueString
        }
        status
        docStatus
        type {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        category {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        date
        custodian {
          __typename
          reference
          display
        }
        description
        content {
          __typename
          attachment {
            __typename
            contentType
            url
            creation
          }
        }
        context {
          __typename
          period {
            __typename
            start
            end
          }
        }
      }
    }
  }
}
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`) as unknown as TypedDocumentString<DocumentReferencesListQuery, DocumentReferencesListQueryVariables>;
export const EncountersDocument = new TypedDocumentString(`
    query Encounters($upid: ID!, $cursor: String!, $sort: EncounterSortParams!, $first: Int!, $filter: EncounterFilterParams! = {}) {
  __typename
  EncounterConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    first: $first
    filter: $filter
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        ...Encounter
      }
    }
  }
}
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}
fragment CodeableConcept on CodeableConcept {
  __typename
  text
  coding {
    __typename
    ...Coding
  }
}
fragment Encounter on Encounter {
  __typename
  id
  resourceType
  BasicList(_reference: "subject") {
    __typename
    ...Basic
  }
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
    versionId
  }
  extension {
    __typename
    url
    valueString
    extension {
      __typename
      url
      valueReference {
        __typename
        id
        type
        reference
      }
    }
  }
  status
  class {
    __typename
    system
    version
    code
    display
  }
  type {
    __typename
    ...CodeableConcept
  }
  serviceType {
    __typename
    ...CodeableConcept
  }
  priority {
    __typename
    ...CodeableConcept
  }
  diagnosis {
    __typename
    condition {
      __typename
      reference
      display
      resource {
        __typename
        ... on Condition {
          __typename
          code {
            __typename
            coding {
              __typename
              ...Coding
            }
            text
          }
        }
      }
    }
  }
  participant {
    __typename
    individual {
      __typename
      reference
      resource {
        __typename
        ... on Practitioner {
          __typename
          name {
            __typename
            family
            given
          }
        }
      }
      display
    }
    type {
      __typename
      ...CodeableConcept
    }
    period {
      __typename
      start
      end
    }
  }
  period {
    __typename
    start
    end
  }
  ProvenanceList(_reference: "target") {
    __typename
    id
    entity {
      __typename
      what {
        __typename
        ...Reference
      }
    }
  }
  length {
    __typename
    value
    unit
  }
  reasonCode {
    __typename
    ...CodeableConcept
  }
  hospitalization {
    __typename
    dischargeDisposition {
      __typename
      ...CodeableConcept
    }
  }
  location {
    __typename
    location {
      __typename
      reference
      display
      resource {
        __typename
        ... on Location {
          __typename
          name
          type {
            __typename
            ...CodeableConcept
          }
        }
      }
    }
    status
    period {
      __typename
      start
      end
    }
  }
}`) as unknown as TypedDocumentString<EncountersQuery, EncountersQueryVariables>;
export const EpisodeOfCareOverviewDocument = new TypedDocumentString(`
    query EpisodeOfCareOverview($upid: ID!, $cursor: String!, $first: Int!, $filter: EpisodeOfCareFilterParams!) {
  __typename
  EpisodeOfCareConnection(
    upid: $upid
    after: $cursor
    first: $first
    filter: $filter
  ) {
    __typename
    pageInfo {
      __typename
      endCursor
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        ...EpisodeOfCareOverview
      }
    }
  }
}
    fragment EpisodeOfCareOverview on EpisodeOfCare {
  __typename
  id
  resourceType
  extension {
    __typename
    url
    extension {
      __typename
      url
      valueReference {
        __typename
        id
        type
        reference
        display
        extension {
          __typename
          url
          valueString
          valueBoolean
        }
      }
      valueString
    }
    valueString
    valueReference {
      __typename
      id
      type
      reference
      display
    }
    valueCodeableConcept {
      __typename
      coding {
        __typename
        system
        code
        display
      }
      text
    }
    valueCoding {
      __typename
      code
      display
      system
      userSelected
      version
    }
  }
  meta {
    __typename
    extension {
      __typename
      url
    }
    security {
      __typename
      system
      code
    }
    tag {
      __typename
      system
      code
    }
    lastUpdated
  }
  period {
    __typename
    start
    end
  }
  status
}`) as unknown as TypedDocumentString<EpisodeOfCareOverviewQuery, EpisodeOfCareOverviewQueryVariables>;
export const EpisodeOfCareDocument = new TypedDocumentString(`
    query EpisodeOfCare($upid: ID!, $cursor: String!, $first: Int!, $filter: EpisodeOfCareFilterParams!) {
  __typename
  EpisodeOfCareConnection(
    upid: $upid
    after: $cursor
    first: $first
    filter: $filter
  ) {
    __typename
    pageInfo {
      __typename
      endCursor
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        ...EpisodeOfCare
      }
    }
  }
}
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}
fragment CodeableConcept on CodeableConcept {
  __typename
  text
  coding {
    __typename
    ...Coding
  }
}
fragment Encounter on Encounter {
  __typename
  id
  resourceType
  BasicList(_reference: "subject") {
    __typename
    ...Basic
  }
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
    versionId
  }
  extension {
    __typename
    url
    valueString
    extension {
      __typename
      url
      valueReference {
        __typename
        id
        type
        reference
      }
    }
  }
  status
  class {
    __typename
    system
    version
    code
    display
  }
  type {
    __typename
    ...CodeableConcept
  }
  serviceType {
    __typename
    ...CodeableConcept
  }
  priority {
    __typename
    ...CodeableConcept
  }
  diagnosis {
    __typename
    condition {
      __typename
      reference
      display
      resource {
        __typename
        ... on Condition {
          __typename
          code {
            __typename
            coding {
              __typename
              ...Coding
            }
            text
          }
        }
      }
    }
  }
  participant {
    __typename
    individual {
      __typename
      reference
      resource {
        __typename
        ... on Practitioner {
          __typename
          name {
            __typename
            family
            given
          }
        }
      }
      display
    }
    type {
      __typename
      ...CodeableConcept
    }
    period {
      __typename
      start
      end
    }
  }
  period {
    __typename
    start
    end
  }
  ProvenanceList(_reference: "target") {
    __typename
    id
    entity {
      __typename
      what {
        __typename
        ...Reference
      }
    }
  }
  length {
    __typename
    value
    unit
  }
  reasonCode {
    __typename
    ...CodeableConcept
  }
  hospitalization {
    __typename
    dischargeDisposition {
      __typename
      ...CodeableConcept
    }
  }
  location {
    __typename
    location {
      __typename
      reference
      display
      resource {
        __typename
        ... on Location {
          __typename
          name
          type {
            __typename
            ...CodeableConcept
          }
        }
      }
    }
    status
    period {
      __typename
      start
      end
    }
  }
}
fragment EpisodeOfCare on EpisodeOfCare {
  __typename
  id
  resourceType
  extension {
    __typename
    url
    extension {
      __typename
      url
      valueReference {
        __typename
        id
        type
        reference
        display
        extension {
          __typename
          url
          valueString
          valueBoolean
        }
        resource {
          __typename
          ... on Encounter {
            __typename
            ...Encounter
          }
        }
      }
      valueString
    }
    valueString
    valueReference {
      __typename
      id
      type
      reference
      display
    }
    valueCodeableConcept {
      __typename
      coding {
        __typename
        system
        code
        display
      }
      text
    }
    valueCoding {
      __typename
      code
      display
      system
      userSelected
      version
    }
  }
  meta {
    __typename
    extension {
      __typename
      url
    }
    security {
      __typename
      system
      code
    }
    tag {
      __typename
      system
      code
    }
    lastUpdated
  }
  period {
    __typename
    start
    end
  }
  identifier {
    __typename
    system
    value
    type {
      __typename
      text
      coding {
        __typename
        system
        code
        display
      }
    }
  }
  status
  diagnosis {
    __typename
    role {
      __typename
      coding {
        __typename
        system
        code
        display
      }
    }
    condition {
      __typename
      id
      type
      reference
      resource {
        __typename
        ... on Condition {
          __typename
          id
          resourceType
          code {
            __typename
            text
            coding {
              __typename
              display
              code
              system
              extension {
                __typename
                url
                valueString
              }
            }
          }
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<EpisodeOfCareQuery, EpisodeOfCareQueryVariables>;
export const ImmunizationsDocument = new TypedDocumentString(`
    query Immunizations($upid: ID!, $cursor: String!, $sort: ImmunizationSortParams!, $filter: ImmunizationFilterParams! = {}, $first: Int!) {
  __typename
  ImmunizationConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    filter: $filter
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        id
        resourceType
        BasicList(_reference: "subject") {
          __typename
          ...Basic
        }
        meta {
          __typename
          tag {
            __typename
            system
            code
          }
          versionId
        }
        extension {
          __typename
          url
          valueString
        }
        status
        statusReason {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        vaccineCode {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        patient {
          __typename
          reference
          resource {
            __typename
            ... on Patient {
              __typename
              ...Patient
              managingOrganization {
                __typename
                resource {
                  __typename
                  ... on Organization {
                    __typename
                    name
                  }
                }
              }
            }
          }
        }
        occurrenceDateTime
        occurrenceString
        recorded
        lotNumber
        expirationDate
      }
    }
  }
}
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Patient on Patient {
  __typename
  id
  resourceType
  meta {
    __typename
    versionId
    extension {
      __typename
      url
      valueString
      valueInstant
    }
    tag {
      __typename
      system
      code
    }
  }
  active
  identifier {
    __typename
    use
    system
    value
  }
  contact {
    __typename
    address {
      __typename
      city
      country
      district
      line
      period {
        __typename
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      __typename
      display
      identifier {
        __typename
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    __typename
    text
    coding {
      __typename
      code
      display
      system
    }
  }
  telecom {
    __typename
    use
    value
    system
  }
  address {
    __typename
    city
    country
    district
    line
    period {
      __typename
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    period {
      __typename
      start
      end
    }
    use
  }
  managingOrganization {
    __typename
    resource {
      __typename
      ...Organization
    }
  }
}
fragment Organization on Organization {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  name
  telecom {
    __typename
    system
    value
    period {
      __typename
      start
      end
    }
  }
  contact {
    __typename
    purpose {
      __typename
      text
      coding {
        __typename
        code
        display
        system
        extension {
          __typename
          url
          valueString
        }
      }
    }
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      __typename
      system
      value
      period {
        __typename
        start
        end
      }
    }
    address {
      __typename
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        __typename
        start
        end
      }
    }
  }
}`) as unknown as TypedDocumentString<ImmunizationsQuery, ImmunizationsQueryVariables>;
export const MedicationAdministrationsDocument = new TypedDocumentString(`
    query MedicationAdministrations($upid: ID!, $cursor: String!, $filter: MedicationAdministrationFilterParams!, $sort: MedicationAdministrationSortParams!, $first: Int!) {
  __typename
  MedicationAdministrationConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        id
        resourceType
        meta {
          __typename
          tag {
            __typename
            system
            code
          }
        }
        extension {
          __typename
          url
          valueString
        }
        dosage {
          __typename
          text
          dose {
            __typename
            value
            unit
          }
          route {
            __typename
            text
            coding {
              __typename
              ...Coding
            }
          }
        }
        effectivePeriod {
          __typename
          start
          end
        }
      }
    }
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`) as unknown as TypedDocumentString<MedicationAdministrationsQuery, MedicationAdministrationsQueryVariables>;
export const MedicationDispensesDocument = new TypedDocumentString(`
    query MedicationDispenses($upid: ID!, $cursor: String!, $filter: MedicationDispenseFilterParams!, $sort: MedicationDispenseSortParams!, $first: Int!) {
  __typename
  MedicationDispenseConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        id
        resourceType
        meta {
          __typename
          tag {
            __typename
            system
            code
          }
        }
        extension {
          __typename
          url
          valueString
          valueInstant
        }
        contained {
          __typename
          resource {
            __typename
            ... on Practitioner {
              __typename
              id
              resourceType
              name {
                __typename
                family
                given
              }
              address {
                __typename
                text
              }
              telecom {
                __typename
                value
              }
            }
            ... on Organization {
              __typename
              id
              resourceType
              _organization__name: name
              telecom {
                __typename
                value
              }
              address {
                __typename
                city
                state
                postalCode
                text
                line
              }
            }
          }
        }
        performer {
          __typename
          actor {
            __typename
            id
            extension {
              __typename
              url
              valueString
            }
            reference
            type
            identifier {
              __typename
              id
              system
              value
            }
            display
            resource {
              __typename
              ... on Organization {
                __typename
                id
                resourceType
                name
                telecom {
                  __typename
                  value
                }
                address {
                  __typename
                  city
                  state
                  postalCode
                  text
                  line
                }
              }
            }
          }
        }
        status
        quantity {
          __typename
          value
          unit
        }
        medicationCodeableConcept {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        daysSupply {
          __typename
          value
          unit
        }
        whenHandedOver
        whenPrepared
      }
    }
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`) as unknown as TypedDocumentString<MedicationDispensesQuery, MedicationDispensesQueryVariables>;
export const MedicationRequestsDocument = new TypedDocumentString(`
    query MedicationRequests($upid: ID!, $cursor: String!, $filter: MedicationRequestFilterParams!, $sort: MedicationRequestSortParams!, $first: Int!) {
  __typename
  MedicationRequestConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        id
        resourceType
        meta {
          __typename
          tag {
            __typename
            system
            code
          }
        }
        extension {
          __typename
          url
          valueString
        }
        authoredOn
        reportedBoolean
        contained {
          __typename
          resource {
            __typename
            ... on Practitioner {
              __typename
              id
              resourceType
              name {
                __typename
                family
                given
              }
              address {
                __typename
                text
              }
              telecom {
                __typename
                value
              }
            }
            ... on Organization {
              __typename
              id
              resourceType
              _organization__name: name
              telecom {
                __typename
                value
              }
              address {
                __typename
                city
                state
                postalCode
                text
                line
              }
            }
          }
        }
        dispenseRequest {
          __typename
          performer {
            __typename
            id
            extension {
              __typename
              url
              valueString
            }
            reference
            type
            identifier {
              __typename
              id
              system
              value
            }
            display
            resource {
              __typename
              ... on Organization {
                __typename
                id
                resourceType
                name
                telecom {
                  __typename
                  value
                }
                address {
                  __typename
                  city
                  state
                  postalCode
                  text
                  line
                }
              }
            }
          }
          numberOfRepeatsAllowed
          initialFill {
            __typename
            quantity {
              __typename
              value
              unit
            }
          }
        }
        dosageInstruction {
          __typename
          text
          timing {
            __typename
            repeat {
              __typename
              boundsPeriod {
                __typename
                start
              }
            }
          }
        }
        medicationCodeableConcept {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        performer {
          __typename
          ...Reference
        }
        requester {
          __typename
          id
          extension {
            __typename
            url
            valueString
          }
          reference
          type
          identifier {
            __typename
            id
            system
            value
          }
          display
          resource {
            __typename
            ... on Practitioner {
              __typename
              id
              resourceType
              name {
                __typename
                family
                given
              }
              address {
                __typename
                text
              }
              telecom {
                __typename
                value
              }
            }
          }
        }
        status
      }
    }
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}`) as unknown as TypedDocumentString<MedicationRequestsQuery, MedicationRequestsQueryVariables>;
export const MedicationStatementsDocument = new TypedDocumentString(`
    query MedicationStatements($upid: ID!, $cursor: String!, $filter: MedicationStatementFilterParams!, $sort: MedicationStatementSortParams!, $first: Int!) {
  __typename
  MedicationStatementConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        id
        resourceType
        BasicList(_reference: "subject") {
          __typename
          ...Basic
        }
        meta {
          __typename
          tag {
            __typename
            system
            code
          }
          versionId
        }
        extension {
          __typename
          url
          extension {
            __typename
            url
            valueReference {
              __typename
              id
              type
              reference
            }
          }
          valueDateTime
          valueString
          valueReference {
            __typename
            id
            type
            reference
            display
          }
          valueQuantity {
            __typename
            unit
            value
          }
          valueUnsignedInt
        }
        basedOn {
          __typename
          type
        }
        category {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        contained {
          __typename
          resource {
            __typename
            ... on Practitioner {
              __typename
              id
              resourceType
              name {
                __typename
                family
                given
              }
            }
            ... on Organization {
              __typename
              id
              resourceType
              _organization__name: name
            }
            ... on Medication {
              __typename
              id
              resourceType
              code {
                __typename
                text
                coding {
                  __typename
                  ...Coding
                }
              }
            }
          }
        }
        context {
          __typename
          display
        }
        dateAsserted
        derivedFrom {
          __typename
          ...Reference
        }
        dosage {
          __typename
          text
        }
        effectivePeriod {
          __typename
          start
        }
        identifier {
          __typename
          value
        }
        informationSource {
          __typename
          type
        }
        medicationCodeableConcept {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        medicationReference {
          __typename
          display
        }
        note {
          __typename
          text
        }
        partOf {
          __typename
          display
        }
        reasonCode {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        reasonReference {
          __typename
          ...Reference
        }
        status
        statusReason {
          __typename
          text
          coding {
            __typename
            ...Coding
          }
        }
        subject {
          __typename
          resource {
            __typename
            ... on Patient {
              __typename
              managingOrganization {
                __typename
                resource {
                  __typename
                  ... on Organization {
                    __typename
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    fragment Basic on Basic {
  __typename
  id
  resourceType
  meta {
    __typename
    lastUpdated
    tag {
      __typename
      system
      code
    }
  }
  code {
    __typename
    coding {
      __typename
      code
      display
      system
    }
  }
  author {
    __typename
    display
  }
}
fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}`) as unknown as TypedDocumentString<MedicationStatementsQuery, MedicationStatementsQueryVariables>;
export const ObservationsDocument = new TypedDocumentString(`
    query Observations($upid: ID!, $cursor: String!, $sort: ObservationSortParams!, $filter: ObservationFilterParams!, $first: Int!) {
  __typename
  ObservationConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        ...Observation
      }
    }
  }
}
    fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}
fragment Observation on Observation {
  __typename
  id
  resourceType
  extension {
    __typename
    url
    valueString
  }
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  encounter {
    __typename
    reference
  }
  status
  category {
    __typename
    text
    coding {
      __typename
      code
      display
      system
      extension {
        __typename
        url
        valueString
      }
    }
  }
  effectivePeriod {
    __typename
    start
    end
  }
  effectiveDateTime
  referenceRange {
    __typename
    text
  }
  code {
    __typename
    text
    coding {
      __typename
      code
      display
      system
      extension {
        __typename
        url
        valueString
      }
    }
  }
  component {
    __typename
    code {
      __typename
      text
      coding {
        __typename
        code
        display
        system
      }
    }
    valueQuantity {
      __typename
      unit
      value
    }
    valueString
  }
  ProvenanceList(_reference: "target") {
    __typename
    id
    entity {
      __typename
      what {
        __typename
        ...Reference
      }
    }
  }
  valueQuantity {
    __typename
    comparator
    unit
    value
    system
    code
  }
  valueCodeableConcept {
    __typename
    text
    coding {
      __typename
      system
      code
      display
    }
  }
  valueString
  valueBoolean
  valueInteger
  valueRange {
    __typename
    low {
      __typename
      unit
      value
      system
      code
    }
    high {
      __typename
      unit
      value
      system
      code
    }
  }
  valueRatio {
    __typename
    numerator {
      __typename
      comparator
      unit
      value
      system
      code
    }
    denominator {
      __typename
      unit
      value
      system
      code
    }
  }
  valueTime
  valueDateTime
  valuePeriod {
    __typename
    start
    end
  }
  interpretation {
    __typename
    text
    coding {
      __typename
      code
      display
      system
      extension {
        __typename
        url
        valueString
      }
    }
  }
  subject {
    __typename
    resource {
      __typename
      ... on Patient {
        __typename
        managingOrganization {
          __typename
          resource {
            __typename
            ... on Organization {
              __typename
              name
            }
          }
        }
      }
    }
  }
  note {
    __typename
    text
  }
}`) as unknown as TypedDocumentString<ObservationsQuery, ObservationsQueryVariables>;
export const ObservationsLiteDocument = new TypedDocumentString(`
    query ObservationsLite($upid: ID!, $cursor: String!, $sort: ObservationSortParams!, $filter: ObservationFilterParams!, $first: Int!) {
  __typename
  ObservationConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        ...ObservationLite
      }
    }
  }
}
    fragment ObservationLite on Observation {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  effectivePeriod {
    __typename
    start
  }
  effectiveDateTime
  referenceRange {
    __typename
    text
  }
  code {
    __typename
    text
    coding {
      __typename
      code
      display
      system
      extension {
        __typename
        url
        valueString
      }
    }
  }
  valueQuantity {
    __typename
    comparator
    unit
    value
    system
    code
  }
  valueCodeableConcept {
    __typename
    text
    coding {
      __typename
      system
      code
      display
    }
  }
  valueString
  valueBoolean
  valueInteger
  valueRange {
    __typename
    low {
      __typename
      unit
      value
      system
      code
    }
    high {
      __typename
      unit
      value
      system
      code
    }
  }
  valueTime
  valueDateTime
  valuePeriod {
    __typename
    start
    end
  }
  interpretation {
    __typename
    text
    coding {
      __typename
      code
      display
      system
      extension {
        __typename
        url
        valueString
      }
    }
  }
  note {
    __typename
    text
  }
}`) as unknown as TypedDocumentString<ObservationsLiteQuery, ObservationsLiteQueryVariables>;
export const PatientsForUpidDocument = new TypedDocumentString(`
    query PatientsForUpid($upid: ID!, $cursor: String!, $sort: PatientSortParams!, $first: Int!, $filter: PatientFilterParams! = {}) {
  __typename
  PatientConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    first: $first
    filter: $filter
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
    }
    edges {
      __typename
      node {
        __typename
        ...Patient
      }
    }
  }
}
    fragment Patient on Patient {
  __typename
  id
  resourceType
  meta {
    __typename
    versionId
    extension {
      __typename
      url
      valueString
      valueInstant
    }
    tag {
      __typename
      system
      code
    }
  }
  active
  identifier {
    __typename
    use
    system
    value
  }
  contact {
    __typename
    address {
      __typename
      city
      country
      district
      line
      period {
        __typename
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    gender
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    organization {
      __typename
      display
      identifier {
        __typename
        value
      }
      type
    }
  }
  birthDate
  gender
  maritalStatus {
    __typename
    text
    coding {
      __typename
      code
      display
      system
    }
  }
  telecom {
    __typename
    use
    value
    system
  }
  address {
    __typename
    city
    country
    district
    line
    period {
      __typename
      start
      end
    }
    postalCode
    state
    text
    type
    use
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    period {
      __typename
      start
      end
    }
    use
  }
  managingOrganization {
    __typename
    resource {
      __typename
      ...Organization
    }
  }
}
fragment Organization on Organization {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  extension {
    __typename
    url
    valueString
  }
  name
  telecom {
    __typename
    system
    value
    period {
      __typename
      start
      end
    }
  }
  contact {
    __typename
    purpose {
      __typename
      text
      coding {
        __typename
        code
        display
        system
        extension {
          __typename
          url
          valueString
        }
      }
    }
    name {
      __typename
      family
      given
      prefix
      suffix
      text
      use
    }
    telecom {
      __typename
      system
      value
      period {
        __typename
        start
        end
      }
    }
    address {
      __typename
      type
      use
      text
      line
      city
      district
      state
      postalCode
      country
      period {
        __typename
        start
        end
      }
    }
  }
}`) as unknown as TypedDocumentString<PatientsForUpidQuery, PatientsForUpidQueryVariables>;
export const PatientsForBuilderDocument = new TypedDocumentString(`
    query PatientsForBuilder($builderID: ID!, $cursor: String!, $first: Int!, $filter: PatientFilterParams! = {}) {
  __typename
  PatientConnection(
    builderID: $builderID
    after: $cursor
    first: $first
    filter: $filter
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        ...PatientListItem
      }
    }
  }
}
    fragment PatientListItem on Patient {
  __typename
  id
  resourceType
  meta {
    __typename
    versionId
    lastUpdated
    extension {
      __typename
      url
      valueString
      valueInstant
    }
  }
  extension {
    __typename
    url
    valueString
  }
  identifier {
    __typename
    use
    system
    value
  }
  name {
    __typename
    family
    given
    prefix
    suffix
    text
    period {
      __typename
      start
      end
    }
    use
  }
  birthDate
  gender
  telecom {
    __typename
    use
    value
    system
  }
}`) as unknown as TypedDocumentString<PatientsForBuilderQuery, PatientsForBuilderQueryVariables>;
export const ProceduresDocument = new TypedDocumentString(`
    query Procedures($upid: ID!, $cursor: String!, $sort: ProcedureSortParams!, $filter: ProcedureFilterParams!, $first: Int!) {
  __typename
  ProcedureConnection(
    upid: $upid
    after: $cursor
    filter: $filter
    sort: $sort
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        ...Procedure
      }
    }
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}
fragment Reference on Reference {
  __typename
  id
  extension {
    __typename
    url
    valueString
  }
  reference
  type
  identifier {
    __typename
    id
    system
    value
  }
  display
}
fragment Procedure on Procedure {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
    extension {
      __typename
      url
      valueReference {
        __typename
        reference
      }
    }
  }
  status
  code {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  category {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  performedDateTime
  performedPeriod {
    __typename
    start
    end
  }
  performedString
  performedAge {
    __typename
    value
    unit
  }
  performedRange {
    __typename
    low {
      __typename
      value
      unit
    }
    high {
      __typename
      value
      unit
    }
  }
  performer {
    __typename
    actor {
      __typename
      display
    }
    function {
      __typename
      text
      coding {
        __typename
        ...Coding
      }
    }
  }
  bodySite {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  reasonCode {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  outcome {
    __typename
    text
    coding {
      __typename
      ...Coding
    }
  }
  ProvenanceList(_reference: "target") {
    __typename
    id
    target {
      __typename
      reference
    }
    entity {
      __typename
      role
      what {
        __typename
        ...Reference
      }
    }
  }
}`) as unknown as TypedDocumentString<ProceduresQuery, ProceduresQueryVariables>;
export const PatientRecordSearchDocument = new TypedDocumentString(`
    query PatientRecordSearch($upid: ID!, $query: String!, $resourceTypes: [String!]) {
  __typename
  SearchConnection(upid: $upid, query: $query, resourceTypes: $resourceTypes) {
    __typename
    edges {
      __typename
      node {
        __typename
        id
        resourceType
        score
        title
        resource {
          __typename
          ... on Binary {
            __typename
            id
            resourceType
          }
          ... on DiagnosticReport {
            __typename
            id
            resourceType
            code {
              __typename
              text
              coding {
                __typename
                ...Coding
              }
            }
            effectiveDateTime
            effectivePeriod {
              __typename
              start
            }
            issued
            result {
              __typename
              reference
              display
            }
          }
        }
        matches {
          __typename
          location
          text
          term
        }
      }
    }
  }
}
    fragment Coding on Coding {
  __typename
  code
  display
  system
  extension {
    __typename
    url
    valueString
    valueCoding {
      __typename
      code
      display
      system
    }
  }
  version
}`) as unknown as TypedDocumentString<PatientRecordSearchQuery, PatientRecordSearchQueryVariables>;
export const ServiceRequestsDocument = new TypedDocumentString(`
    query ServiceRequests($upid: ID!, $cursor: String!, $sort: ServiceRequestSortParams!, $filter: ServiceRequestFilterParams! = {}, $first: Int!) {
  __typename
  ServiceRequestConnection(
    upid: $upid
    after: $cursor
    sort: $sort
    filter: $filter
    first: $first
  ) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      endCursor
    }
    edges {
      __typename
      node {
        __typename
        ...ServiceRequest
      }
    }
  }
}
    fragment ServiceRequest on ServiceRequest {
  __typename
  id
  resourceType
  meta {
    __typename
    tag {
      __typename
      system
      code
    }
  }
  status
  intent
  subject {
    __typename
    reference
  }
  identifier {
    __typename
    system
    value
  }
  requester {
    __typename
    resource {
      __typename
      ... on Practitioner {
        __typename
        id
        resourceType
        extension {
          __typename
          url
          valueString
        }
        name {
          __typename
          family
          given
          prefix
          suffix
          text
          use
        }
        qualification {
          __typename
          code {
            __typename
            text
            coding {
              __typename
              code
              display
              system
            }
          }
          period {
            __typename
            start
            end
          }
        }
      }
    }
    reference
    identifier {
      __typename
      system
      value
    }
    display
  }
  reasonCode {
    __typename
    text
  }
  authoredOn
  category {
    __typename
    text
  }
  performer {
    __typename
    reference
    identifier {
      __typename
      system
      value
    }
    display
  }
  locationReference {
    __typename
    reference
    display
  }
}`) as unknown as TypedDocumentString<ServiceRequestsQuery, ServiceRequestsQueryVariables>;
export const PatientUpiRecordTypeTagStatusDocument = new TypedDocumentString(`
    query PatientUpiRecordTypeTagStatus($upid: ID!, $tag: String!) {
  __typename
  taggedPatients: PatientConnection(
    upid: $upid
    first: 1
    filter: {tag: {anymatch: [$tag]}}
  ) {
    __typename
    edges {
      __typename
      node {
        __typename
        id
      }
    }
  }
  allPatients: PatientConnection(upid: $upid, first: 1) {
    __typename
    edges {
      __typename
      node {
        __typename
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PatientUpiRecordTypeTagStatusQuery, PatientUpiRecordTypeTagStatusQueryVariables>;